const measurements = {
  label: 'Measurements',
  GROSS_WEIGHT: 'Gross weight',
  GROSS_VOLUME: 'Gross volume',
};
const referenceNumberLabels = {
  QUOTATION: 'Numer kwotowania',
  CARRIER_RATE_REFERENCE: 'Numer stawki przewoźnika',
  STANDARD_TARIFF: 'Numer standardowej taryfy',
  BILL_OF_LADING_REFERENCE: 'Numer konosamentu',
  BOOKING_NUMBER: 'Numer Bukingu',
  CUSTOMER_REFERENCE: 'Numer klienta',
  SERVICE_CONTRACT: 'Numer kontraktu',
  FORWARDER_REFERENCE: 'Numer spedytora',
  INVOICE_NUMBER: 'Numer faktury',
  SHIPPING_ORDER_NUMBER: 'Numer zamówienia żeglugi',
  PURCHASE_ORDER: 'Numer zamówienia zakupu',
  SHIPPER_IDENTIFYING: 'ID wysyłki',
  CARGOSMART_REFERENCE: 'Numer Cargo Smart',
  SHIPPER_REFERENCE: 'Numer referencyjny nadawcy przesyłki',
  CONSIGNEE_SHIPMENT_REFERENCE: 'Numer referencyjny odbiorcy przesyłki',
  CONTRACT_PARTY_REFERENCE: 'Numer referencyjny kontraktora',
  MUTUALLY_DEFINED_REFERENCE: 'Numer referencyjny ustalony z przewoźnikiem',
  FREIGHT_TARIFF_REFERENCE: 'Numer taryfy frachtu',
  INTTRA_CONTRACT_PARTY_REFERENCE: 'Numer referencyjny kontraktora',
  AGENT_REFERENCE: 'Numer referencyjny agenta',
  VEHICLE_IDENTIFICATION_NUMBER: 'VIN',
  CONSIGNEES_REFERENCE: 'Numer referencyjny odbiorcy',
  EXPORT_LICENCE_REFERENCE: 'Numer referencyjny licencji eksportowej',
  FREIGHT_FORWARDERS_NUMBER: 'Numer referencyjny spedytora',
  CONTRACT_LINE_ITEM_NUMBER: 'Numer referencyjny linii kontraktu',
  INTTRA_REFERENCE_NUMBER: 'Numer referencyjny INTTRA',
};

export const plTranslations = {
  localeCode: 'pl',
  misc: {
    boolean: {
      true: 'tak',
      false: 'nie',
    },
    languages: {
      PL: 'PL',
      GB: 'EN',
    },
    button: {
      cancel: 'Anuluj',
      create: 'Dodaj',
      delete: 'Usuń',
      details: 'Szczegóły',
      list: 'Lista',
      save: 'Zapisz',
      send: 'Wyślij',
      search: 'Szukaj',
      addFunction: 'Dodaj funkcję',
      deleteFunction: 'Usuń funkcję',
      print: 'Drukuj',
      publish: 'Publikuj',
      unpublish: 'Cofnij',
      reset: 'Reset',
      edit: 'Edytuj',
      copy: 'Kopiuj',
      close: 'Zamknij',
      mail: 'Wyślij',
      addItem: 'Dodaj pozycję',
      upload: 'Wyślij plik',
      uploadPdf: 'Wyślij plik (pdf)',
      generateInvoice: 'Faktura',
      finish: 'Zakończ',
      next: 'Dalej',
      prev: 'Wstecz',
      new: 'Dodaj',
      import: 'Importuj',
      complete: 'Zakończ',
      accept: 'Zatwierdź',
      generate: 'Wygeneruj plik',
      download: 'Pobierz plik',
      openAll: 'Otwórz wszystkie',
      closeAll: 'Zamknij wszystkie',
      confirm: 'Potwierdź',
      export: 'Eksport',
      yes: 'Tak',
      no: 'Nie',
      reject: 'Odrzuć',
      updateBookingRequest: 'Aktualizuj buking',
      cancelBookingRequest: 'Anuluj buking',
      copyEvent: 'Kopiuj wydarzenie',
      duplicate: 'Duplikuj',
      saldeoFetch: 'Pobierz z Saldeo',
      enovaFetch: 'Pobierz z Enovy',
      showMore: '+{{count}} więcej...',
    },
    message: {
      generalError: 'Wystąpił błąd: ',
      deleteSuccess: 'Wpis usunięty.',
      deleteFailure: 'Wystąpił błąd podczas usuwania wpisu.',
      createSuccess: 'Wpis dodany',
      createFailure: 'Wystąpił błąd podczas tworzenia wpisu.',
      duplicateSuccess:
        'Stworzono duplikat stawki. Przeniesiono do strony nowo utworzonej stawki.',
      duplicateFailure: 'Wystąpił błąd podczas duplikacji stawki.',
      updateSuccess: 'Wpis zaktualizowany',
      updateFailure: 'Wystąpił błąd podczas aktualizacji wpisu.',
      accessDenied: 'Brak uprawnień do wykonania operacji.',
      contactAdministrator: 'Skontaktuj się z administratorem.',
      acceptSuccess: 'Alokacja potwierdzona',
      gusError: 'Nie można pobrać danych z GUS',
      updateUserPermissions:
        'Zaktualizowano uprawnienia. Zmiany będą widoczne po ponownym zalogowaniu.',
      exportSuccess: 'Wyeksportowano {{exported}} z {{total}} faktur.',
      exportTestSuccess: 'Eksport do Enovy zakończony (wersja testowa).',
      exportTestNotice:
        'Plik został tylko pobrany do weryfikacji poprawności. Dane nie zostały wysłane do Enovy.',
      exportPartial:
        'Wysłano {{exported}} z {{total}} faktur do Enova. Sprawdź błędy i/lub skontaktuj się z administracją.',
      exportFailed:
        'Nie wyeksportowano żadnej faktury. Sprawdź błędy i/lub skontaktuj się z administracją.',
      lackOfDueDays:
        'Skontaktuj się z osobą odpowiedzialną za ustawienie terminów płatności kontrahenta.',
      downloadFailed: 'Pobranie pliku nie powiodło się.',
      newMessage: 'Nowa wiadomość!',
      outdatedOwnInvoices:
        'Posiadasz faktury własne oczekujące na publikację, opublikuj lub anuluj je przechodząc ',
      outdatedAdministrativeInvoices:
        'Posiadasz faktury administracyjne oczekujące na publikację, opublikuj lub anuluj je przechodząc ',
      goToOutdatedInvoices: 'tutaj.',
      bookingRequestSend: 'Buking wysłany',
      bookingRequestUpdated: 'Aktualizacja bukingu wysłana',
      bookingRequestCancelled: 'Anulowanie bukingu wysłane',
    },
    status: {
      INTERNAL_SERVER_ERROR: 'Wewnętrzny błąd serwera',
      BAD_REQUEST: 'Nieprawidłowe żądanie',
      NOT_FOUND: 'Nie znaleziono',
    },
    errors: {
      BaseInvoiceMissingKsefNumber:
        'Podstawowa faktura nie posiada numeru KSeF w Storm. Zaimportuj potwierdzenie KSeF, aby wystawić korektę.',
      DataAccess: 'Błąd dostępu do danych.',
      DeletingOwnInvoice: 'Opublikowane własne faktury nie mogą być anulowane.',
      EncryptionFailed: 'Błąd szyfrowania.',
      EntityNotFound: 'Żądany obiekt nie istnieje.',
      ForbiddenReplacementAttempt:
        'Nie możesz zastępować wybranego użytkownika.',
      HttpParsing: 'Nieprawidłowe żądanie',
      InvoiceAllocationSum:
        'Łączna kwota alokacji jest większa od wartości faktury.',
      ItemDisabled: 'Element {{1}} {{2}} jest zablokowany.',
      ItemDisabledTypes: {
        Region: 'Region',
        ContainerSize: 'Rozmiar kontenera',
        CurrencyCode: 'Kod waluty',
        Forecast: 'Prognoza',
        ProductGroup: 'Grupa produktów',
        Clause: 'Klauzula',
        Unit: 'Jednostka',
        Trucker: 'Przewoźnik',
        Terminal: 'Terminal',
        ShippingLine: 'Armator',
        Agent: 'Agent',
        CustomsAgency: 'Agencja Celna',
        Customer: 'Klient',
        Other: 'Inny',
        Depot: 'Depot',
        Insurer: 'Ubezpieczyciel',
        User: 'Użytkownik',
        TransportMode: 'Rodzaj transportu',
        Port: 'Port',
        StoreHouse: 'Magazyn',
        Package: 'Opakowanie',
        EDIParty: 'Odbiorca',
        Role: 'Rola',
        Counterparty: 'Kontrahent',
        Responsibility: 'Funkcja',
        InvoiceClass: 'Rodzaj faktury',
        ItemConfiguration: 'Konfiguracja',
        Container: 'Kontener',
        Group: 'Grupa',
        Lot: 'Plac',
        Branch: 'Oddział',
        TaxRate: 'Stawka VAT',
        Activity: 'Usługa spedycyjna',
        ContainerType: 'Typ kontenera',
      },
      NoActiveReplacement: 'Brak aktywnego zastępstwa.',
      NoDefaultUnit: 'Brak domyślnej jednostki usługi.',
      NoPrimaryCounterparty: 'Brak głównego kontrahenta.',
      NoPrimaryCurrencyCode: 'Brak głównej waluty.',
      Storm: 'Błąd aplikacji',
      XmlSerialization: 'Błąd eksportowania faktur',
      DeletingCorrectedInvoice:
        'Nie można usunąć skorygowanej faktury - usuń najpierw fakturę korekcyjną.',
      ExchangeRateNotFound:
        'Kurs wymiany dla wybranej waluty jest niedostępny.',
      NoEmailCredentials:
        'Nie można wysyłać wiadomości email bez uzupełnionych ustawień email',
      DeletingCustomerWithOffer:
        'Nie można usunąć klienta, któremu złożono ofertę',
      DeletingJobWithAllocatedInvoice:
        'Nie można usunąć spedycji, która ma fakturę z zaakceptowaną alokacją.',
      TerminalPriceExists: 'Cena dla podanej konfiguracji już istnieje.',
      InvalidCountryCode: 'Podany kod kraju jest nieprawidłowy.',
      RowAlreadyExists: 'Nie można zapisać ponieważ wpis już istnieje',
      ContainerAlreadyPresentInJob:
        'Kontener z tym numerem już został dodany do spedycji.',
      BusinessFunctionTypeAlreadyPresent:
        'Kontrahent posiada już taką funkcję.',
      NotPossibleToDelete:
        'Nie można usunąć obiektu ponieważ posiada on aktywne powiązania w systemie.',
      TransportRateOverlap: 'Dystanse się nakładają z innymi rekordami.',
      ItemConfigurationExists:
        'Konfiguracja dla wybranego typu, relacji i kategorii już istnieje.',
      PrimaryCounterpartyInvalidFunction:
        'Wybrana funkcja jest niedostępna dla głównego kontrahenta.',
      CannotSendMail:
        'Nie można wysłać wiadomości - niepoprawne ustawienia email (błędne konto email)',
      CannotAuthenticateMail:
        'Nie można wysłać wiadomości - niepoprawne ustawienia email (błędne hasło email)',
      UserLoggedIn: 'Nie można usunąć zalogowanego użytkownika.',
      DeletingAllocatedInvoiceLine:
        'Nie można usunąć linii z faktury, która została zaalokowana.',
      ExcelImportFormat: 'Wybrany plik nie jest poprawnie sformatowany.',
      ExcelImportCellData: 'Nieprawidłowe dane w arkuszu %1 komórce %2',
      ExcelImportEntityData: 'Nieprawidłowe dane w arkuszu %1 wiersz %2',
      InvoiceDeleted: 'Nie można wykonać akcji dla usuniętej faktury.',
      InvoiceIssueDate: 'Nieprawidłowa data wystawienia',
      InvoiceNotPublished: 'Faktura korygowana nie została opublikowana.',
      UnknownInvoiceClass: 'Nieznany typ faktury.',
      PreviousPassword: 'Niepoprawne hasło. Spróbuj jeszcze raz.',
      ItemConfigurationDisabledForActivity:
        'Wybrana usługa nie jest dostępna dla wybranej relacji.',
      UserIsKeeper:
        'Użytkownik nie może zostać przypisany do panelu klienta ponieważ jest opiekunem innego klienta.',
      InvoiceAlreadyCorrected: 'Faktura została już skorygowana.',
      GUSCounterpartyNotFound:
        'Kontrahent o podanym NIP-ie nie został znaleziony w bazie GUS.',
      GUSInvalidCaptcha: 'Niepoprawny kod captcha.',
      GUSServiceLoginFailed: 'Wystąpił problem przy połączeniu z usługą GUS.',
      GUSSessionExpired: 'Niepoprawny kod captcha.', // this is intentionally the same as GUSInvalidCaptcha - no need to burden the user with unneccessary technical details
      NoDocument: 'Wydrukowanie tego dokumentu nie jest możliwe',
      AccountingDocumentIsCancelled: 'Faktura jest już anulowana.',
      AccountingDocumentIsExported: 'Faktura jest już wyeksportowana.',
      AccountingDocumentIsNotReady: 'Faktura musi być najpierw opublikowana.',
      AccountingDocumentIsNotDraft: 'Faktura nie jest edytowalna.',
      JobIsBilled: 'Spedycja jest już rozliczona.',
      JobIsCancelled: 'Spedycja jest już anulowana.',
      JobIsNotFinalized: 'Spedycja musi być najpierw zakończona.',
      JobAccountEntryIsAccepted: 'Alokacja jest już zaakceptowana.',
      AcceptedAllocations: 'Istnieje przynajmniej jedna zatwierdzona alokacja.',
      ExistingAllocations: 'Istnieją alokacje.',
      JobExecutionDateNotSet: 'Brak daty wykonania spedycji.',
      ExistingNotExportedInvoices: 'Nie wszystkie faktury są wyeksportowane.',
      MissingOwnInvoiceAllocation:
        'Spedycja nie ma zaalokowanej faktury własnej.',
      AllocationProcessIsNotFinished: 'Proces alokacji nie jest zakończony.',
      JobIsNotOpen: 'Spedycja jest zamknięta.',
      JobAccountEntryLimitExceeded: 'Suma alokacji przekracza kwotę faktury.',
      OwnAccountingDocumentInvalidOperation:
        'Operacja niedozwolona dla faktur własnych.',
      JobAccountEntryIsNotAccepted:
        'Istnieje przynajmniej jedna niezatwierdzona alokacja.',
      JobIsFullyInvoiced: 'Wszystkie usługi zostały już zafakturowane.',
      NoJobItemsToInvoice:
        'Spedycja {1} nie posiada usług, któe mogą zostać zafakturowane',
      JobHasLessItemsThanInvoiced:
        'Spedycja posiada mniej usług niż już zafakturowano.',
      NotSuperUser: 'Wymagane uprawnienia superużytkownika.',
      NoInvoicesToExport: 'Brak faktur do wyeksportowania.',
      DeletedInvoiceLineStillPresent:
        'Wystąpił błąd podczas usuwania linii faktury, spróbuj ponownie po odświeżeniu strony.',
      InvoiceLineAmountSumMismatch:
        'Suma kwot z linii nie zgadza się z wartością w polu suma faktury.',
      UploadedFileSizeLimitExceeded: 'Rozmiar pliku przekracza 10MB.',
      StoreHouseExistsInDatabase: 'Magazyn już istnieje w bazie.',
      EmptyFields: 'Wymagane pola nie zostały uzupełnione.',
      ClientRolePermission:
        'Rola nie może mieć wybranych innych uprawnień, gdy jest wybrane uprawnienie klienta.',
      CustomerNotSelected:
        'Jeden z użytkowników przypisanych do roli nie ma konta w panelu klienta.',
      OceanSchedulesAuthenticationFailed:
        'Autentykacja na serwerze Inttra nie powiodła się',
      OceanSchedulesInvalidRequest:
        'Nieprawidłowe zapytanie o harmonogram frachtów',
      WrongServiceTermsFileExtension:
        'Błędne rozszerzenie pliku OWŚU. Dodaj plik z rozszerzeniem pdf.',
      InvalidTrackAndTraceFile: 'Otrzymany plik Track and Trace zawiera błędy',
      SendingWithoutInttraReference:
        'Nie znaleziono numeru Inttra ref. w Booking Confirmation.',
      OceanSchedulesInternalError: 'Wystąpił błąd po stronie serwisu Inttra',
      ShippingInstructionNotFound:
        'Nie znaleziono listu przewozowego dla kontenera {1}',
      BookingRequestNotFound:
        'Nie znaleziono potwierdzonego żądania bukingu dla kontenera {1}',
      FreightNotFound: 'Nie znaleziono frachtu dla kontenera {1}',
      TerminalNotSupported: 'Wybrany terminal nie jest wspierany',
      JiraConnection: 'Zgłoszenie błędu tymczasowo niedostępne.',
      ClientGroupPermission:
        'Grupa z rolą "Klient" nie może być zmieniona ani mieć przypisanej żadnej dodatkowej roli.',
      NoCorrectedLines:
        'Publikacja nie jest możliwa bez uzupełnionych linii faktury.',
      EmptyScacCode: 'Kod SCAC nie jest uzupełniony dla wybranego armatora.',
      BrFormValidation:
        'Formularz nie zawiera wszystkich wymaganych pól dla wybranego armatora. {1}.',
      UserWithoutPhone: 'Proszę uzupełnić numer telefonu w swoim profilu',
      InvoiceLineFromJobHasNegativeQuantity:
        'Jedna z usług w spedycji ma za dużo zafakturowanych ładunków',
      SeaportCodeExists: 'Kod portu jest już ustawiony dla portu {2}, {1}',
      InvoiceAlreadyExported:
        'Wybrana faktura została wyeksportowana wcześniej. Nie ma możliwości wielokrotnego eksportowania jednej faktury.',
      InternalChargeExport:
        "Nie można eksportować do Enovy faktury typu 'Obciążenie wewnętrzne'",
    },
    modal: {
      header: 'Uwaga',
      createEntityHeading: 'Stwórz wpis',
      updateEntityHeading: 'Aktualizuj wpis',
      copyEntityHeading: 'Kopiuj wpis: ',
      deleteEntityHeading: 'Potwierdź usunięcie',
      deleteEntityBody: 'Czy na pewno chcesz usunąć ten wpis?',
      deleteRateBody: 'Czy na pewno chcesz usunąć wybrane stawki?',
      deleteEntityForeverBody:
        'Czy na pewno chcesz usunąć ten wpis? Ta operacja nie może zostać cofnięta. ',
      publishHeading: 'Publikuj',
      publishOfferBody:
        'Czy na pewno chcesz opublikować ofertę? Ta operacja nie może zostać cofnięta.',
      publishAnnexBody:
        'Czy na pewno chcesz opublikować ten Aneks? Ta operacja nie może zostać cofnięta.',
      publishInvoiceBody: 'Czy na pewno chcesz opublikować fakturę?',
      publishAlert: 'Po publikacji faktura będzie widoczna w panelu klienta',
      acceptAllocationHeading: 'Potwierdź zatwierdzenie alokacji',
      acceptAllocationBody:
        'Czy na pewno chcesz zatwierdzić alokację? Ta operacja nie może zostać cofnięta.',
      rejectAllocationHeading: 'Potwierdź odrzucenie alokacji',
      rejectAllocationBody:
        'Czy na pewno chcesz odrzucić alokację? Ta operacja nie może zostać cofnięta.',
      rejectAllocationReasonLabel: 'Podaj powód odrzucenia alokacji:',
      markForCorrectionAllocationHeading: 'Potwierdź reklamację alokacji',
      markForCorrectionAllocationBody:
        'Czy na pewno chcesz reklamować alokację?',
      markForCorrectionAllocationReasonLabel:
        'Podaj powód reklamacji alokacji:',
      clearCorrectionRequiredMarkingHeading: 'Odrzuć reklamację',
      clearCorrectionRequiredMarkingBody:
        'Czy na pewno chcesz odrzucić reklamację faktury?',
      updateUserPermissionsHeading: 'Zmiana uprawnień użytkownika',
      updateUserPermissionsBody:
        'Zmiany będą widoczne po ponownym zalogowaniu się.',
      unpublishHeading: 'Cofnij publikację',
      unpublishInvoiceBody:
        'Czy jesteś pewien, że chcesz cofnąć publikacje? Jakiekolwiek zmiany finansowe spowodują usunięcie wszystkich istniejących alokacji.',
      exportInvoiceHeader: 'Eksport',
      exportInvoiceBody:
        'Czy jesteś pewien że chcesz wyeksportować zaznaczone faktury? Ta operacja nie może być cofnięta.',
      deleteCorrectedHeading: 'Usuwanie faktury',
      deleteCorrectedBody:
        'Istnieją faktury korygujące dla tej faktury. Jej usunięcie spowoduje również usunięcie wszystkich faktur korekcyjnych. Czy jesteś pewien?',
      publishOfferAlert:
        'Po publikacji oferta będzie widoczna w panelu klienta',
      publishAnnexAlert: 'Po publikacji aneks będzie widoczny w panelu klienta',
      currencyWarningBody:
        'Zmiana waluty spowoduje usunięcie wszystkich pozycji dodanych do faktury. Czy na pewno chcesz zmienić walutę?',
      withdrawCorrectingAllocationHeading: 'Potwierdź odwołanie reklamacji',
      withdrawCorrectingAllocationBody:
        'Czy na pewno chcesz odwołać reklamację? Ta operacja nie może zostać cofnięta.',
    },
    combobox: {
      noMatches: 'Brak wyników',
      loadMore: 'Ładowanie więcej wyników...',
      searching: 'Wyszukiwanie...',
    },
    offerCompleted: {
      COMPLETED: 'zrealizowane',
      UNCOMPLETED: 'niezrealizowane',
    },
    amount: 'Ilość',
    load: 'Ładunek',
    name: 'Nazwa',
    enabled: 'Aktywny',
    disabled: 'Nieaktywny',
    comment: 'Notatka wewnętrzna',
    creationDate: 'Data utworzenia',
    executionDate: 'Data wykonania',
    expirationDate: 'Data ważności',
    description: 'Opis',
    terminals: 'Terminale',
    data: 'Dane',
    summary: 'Podsumowanie',
    details: 'Widok szczegółowy',
    code: 'Kod',
    inttraName: 'Nazwa',
    type: 'Typ',
    size: 'Rozmiar',
    value: 'Wartość',
    percentValue: 'Wartość (%)',
    edit: 'Edycja',
    date: 'Data',
    owner: 'Właściciel',
    label: 'Etykieta',
    actions: 'Akcje',
    file: 'Plik',
    startDate: 'Od daty wystawienia',
    endDate: 'Do daty wystawienia',
    body: 'Treść',
    onlyMine: 'Tylko moje',
    onlyCurrent: 'Tylko aktualne',
    onlyUnacceptedAllocations: 'Niezaakceptowane alokacje',
    from: 'Od',
    to: 'Do',
    unit: 'Jednostka',
    onlyWithTerminals: 'Tylko z terminalami',
    table: 'Tabela',
    year: 'Rok',
    sender: 'Nadawca',
    ordinal: 'Lp',
    dateFrom: 'Data od',
    dateTo: 'Data do',
    selectAll: 'Zaznacz wszystkie',
    language: 'Język',
  },
  offer: {
    code: 'Numer oferty',
    data: 'Dane oferty',
    publicationDate: 'Data publikacji',
    receiveDate: 'Data otrzymania',
    owner: 'Właściciel',
    tradeType: 'Relacja',
    netAmount: 'Cena netto',
    grossAmount: 'Cena brutto',
    markup: 'Marża',
    currencyCode: 'Waluta',
    customer: 'Klient',
    record: 'Rekord',
    ordinalNumber: 'Numer porządkowy',
    customsAgency: 'Agencja celna',
    depot: 'Depot',
    insurer: 'Ubezpieczyciel',
    agent: 'Agent',
    shippingLine: 'Armator',
    terminal: 'Terminal',
    trucker: 'Przewoźnik',
    unit: 'Jednostka',
    activity: 'Usługa',
    quantity: 'Ilość',
    route: 'Trasa',
    approximateShippingTime: 'TT',
    addRecord: 'Dodaj aneks',
    createOfferFromTemplate: 'Utwórz ofertę',
    createOffer: 'Dodaj ofertę',
    createOfferTemplate: 'Dodaj szablon oferty',
    copyOffer: 'Kopiuj ofertę',
    copyTemplate: 'Kopiuj szablon',
    fromWaypoint: 'Początek',
    toWaypoint: 'Koniec',
    relayWaypoints: 'Przez',
    insuranceRate: 'Stawka ‰',
    insuranceDescription: '%1‰ z %2% wartości ładunku',
    multiplyFactor: 'Mnożnik %',
    items: 'Oferta',
    annex: 'Aneks',
    createTemplate: 'Dodaj szablon',
    addItem: 'Dodaj pozycję',
    offerPublicated: 'Po publikacji oferta będzie widoczna w panelu klienta',
    annexPublicated: 'Po publikacji aneks będzie widoczny w panelu klienta',
    clientPanelDraft:
      'Pełna oferta dostępna jest na wydrukach. Poniższy widok jest tylko poglądowy!',
    cyclicalOffer: 'Oferta cykliczna',
    reminderLabelBefore: 'Przypomnij mi',
    reminderLabelAfter: 'dni przed końcem',
    reminderDateError: 'Przypomnienie nie może przekraczać dzisiejszej daty',
    job: {
      createJobButton: 'Utwórz spedycję',
      modalHeader: 'Spedycja',
      modalSave: 'Stwórz',
      codeInfo: 'przypisywany automatycznie',
      executionDateInfo: 'modyfikowalne po utworzeniu',
      ownerInfo: 'zalogowany użytkownik',
      noJobWithoutCustomer:
        'Aby utworzyć spedycję dodaj do bieżącego kontrahenta funkcję klienta.',
    },
    item: {
      allin: 'All-in',
      customs: 'Obsługa celna',
      depot: 'Depot',
      freight: 'Fracht',
      freightmaintenance: 'Okołofrachtowe',
      insurance: 'Ubezpieczenie',
      other: 'Inny',
      terminal: 'Opłata terminalowa',
      transport: 'Transport lądowy',
    },
    offerType: 'Typ ofert',
    offerTypeLabels: {
      OFFER: 'Oferty',
      TEMPLATE: 'Szablony',
    },
    createOrder: 'Utwórz zlecenie',
    order: 'Zlecenie',
    orderWizard: {
      summaryInformation:
        'Wysłanie zlecenia nie jest jednoznaczne z przyjęciem go do realizacji. Przyjęcie zlecenie musi zostać potwierdzone przez pracownika firmy',
      information:
        'Proszę o wybranie tylko jednej trasy związanej z jednym konosamentem.',
      modalHeader: 'Zlecenie',
    },
    exchangeRate: 'Kurs wymiany {currency}',
    allInMoreThanOneFreight: 'Usługa All-in może zawierać tylko jeden fracht.',
    expirationDate: 'Data ważności oferty',
  },
  order: {
    order: 'Zlecenie',
    recipent: 'Odbiorca zlecenia',
    productGroup: 'Grupa produktów',
    loadName: 'Nazwa ładunku',
    readinessDate: 'Data gotowości',
    customsClearanceType: 'Miejsce odprawy celnej',
    customsClearanceAddress: 'Adres odprawy celnej',
    containerCount: 'Ilość kontenerów',
    quantity: 'Ilość',
    totalWeight: 'Całkowita waga ładunku',
    totalCubature: 'Całkowita kubatura ładunku',
    comment: 'Uwagi',
    sent: 'Zlecenie wysłane',
    orderReceive:
      'Otrzymałeś nowe zlecenie {0} (Todo: no order table). Kliknij by zobaczyć szczegóły',
    orderNumber: 'Numer zlecenia',
    offerNumber: 'Numer oferty',
    sendDate: 'Data wysłania',
    recipient: 'Odbiorca zlecenia',
    createJob: 'Utwórz spedycję',
    reject: 'Odrzuć',
    rejectOrderHeader: 'Odrzuć',
    rejectOrderBody: 'Czy na pewno chcesz odrzucić to zlecenie?',
    status: {
      SENT: 'Odebrane',
      ACCEPTED: 'Zaakceptowane',
      REJECTED: 'Odrzucone',
      label: 'Status zlecenia',
    },
    clientStatus: {
      SENT: 'Wysłane',
      ACCEPTED: 'Zaakceptowane',
      REJECTED: 'Odrzucone',
    },
  },
  job: {
    job: 'Spedycja',
    code: 'Numer spedycji',
    invoiceButtonContainerHint:
      'Wystawienie faktury jest niemożliwe – proszę uzupełnić numery kontenerów.',
    invoiceButtonJobItemsHint:
      'Wystawienie faktury jest niemożliwe - wszystkie usługi zostały już zafakturowane.',
    estimation: 'ETA/ETD',
    customsClearance: 'Odprawa',
    creation: {
      differentFreightRoutes: 'Wszystkie frachty muszą mieć tą samą trasę.',
    },
    search: {
      startCreationDate: 'Od daty utworzenia',
      endCreationDate: 'Do daty utworzenia',
      withMissingVgm: 'VGM',
    },
    general: {
      tabTitle: 'Informacje',
      data: {
        sectionTitle: 'Dane spedycji',
        commissioner: 'Zlecający',
        tradeType: 'Relacja',
        loadType: 'Kategoria',
        customer: 'Klient',
        offer: 'Oferta',
        goToOffer: 'Idź do oferty',
        goToOrder: 'Idź do zlecenia',
        readinessDate: 'Data gotowości',
        bookingNumber: 'Numer bukingu',
        netValueAllocationSum: 'Wynik finansowy',
        netValueAllocationSumForecast: 'Prognoza wyniku',
        owner: 'Opiekun',
        futureExecutionDate:
          'Proszę wprowadzić datę pomiędzy {0} i datą dzisiejszą.',
        executionConfirmationBody:
          'Poniższe usługi nie mają wypełnionych wszystkich detali niezbędnych do wystawienia za nie faktury:',
        executionConfirmationHeader: 'Potwierdź wykonanie spedycji',
        executionConfirmationContinue: 'Czy chcesz kontynuować?',
        bookingRequestAttachmentDownload: 'Pobierz załącznik',
        status: 'Status',
        statusLabels: {
          IN_PROGRESS: 'W trakcie',
          FINALIZED: 'Zakończona',
          BILLED: 'Rozliczona',
          CANCELLED: 'Anulowana',
        },
      },
    },
    entries: {
      ContainerJobEntry: 'Kontener',
      ContainerJobEntryTotal: 'Suma',
      TarpaulinJobEntry: 'Plandeka',
      SmallLoadJobEntry: 'Drobnica',
      releaseContainerUnderDetention: 'Zdejmij stopkę celną',
    },
    loads: {
      captured: 'Po imporcie',
      tabTitle: 'Ładunki',
      productGroup: 'Grupa produktów',
      bulk: 'Luzem',
      quantity: 'Liczba palet',
      packageType: 'Typ opakowania',
      packageCount: 'Liczba opakowań',
      loadDescription: 'Opis ładunku',
      netWeight: 'Masa netto (kg)',
      grossWeight: 'Masa brutto (kg)',
      declaredWeight: 'Waga',
      seals: 'Plomby',
      harmonizedSystemCode: 'Kody HS',
      containerCode: 'Numer kontenera',
      containerSize: 'Rozmiar kontenera',
      containerType: 'Typ kontenera',
      containerSort: 'Rodzaj kontenera',
      containerSortShort: 'Rodzaj',
      relatedServices: 'Usługi',
      createJob: 'Szczegóły',
      summary: 'Podsumowanie',
      route: 'Trasa',
      hideTrucker: 'Ukryj przewoźnika',
      showTrucker: 'Pokaż przewoźnika',
      hideRoute: 'Ukryj trasę',
      showRoute: 'Pokaż trasę',
      contactPerson: 'Osoba kontaktowa',
      technicalStateControl: 'Ocena stanu technicznego',
      waybillClauses: 'Klazule listu przewozowego',
      containerOrderClausesImport: 'Klauzule zlecenia złożenia kont.',
      containerOrderClausesExport: 'Klauzule zlecenia podjęcia kont.',
      transportMode: 'Wymagany środek transportu',
      stackable: 'Piętrowalny',
      adr: 'ADR',
      unCode: 'Kod UN',
      adrClass: 'Klasa ADR',
      packingGroup: 'Grupa pakowania',
      exportCustomsClearance: 'Export',
      importCustomsClearance: 'Import',
    },
    items: {
      AllInJobItem: 'All-in',
      CustomsJobItem: 'Obsługa celna',
      DepotJobItem: 'Depot',
      FreightJobItem: 'Frachty',
      FreightMaintenanceJobItem: 'Okołofrachtowe',
      InsuranceJobItem: 'Ubezpieczenia',
      TerminalJobItem: 'Terminale',
      TransportJobItem: 'Transport',
      OtherJobItem: 'Inne',
    },
    counterparties: {
      CustomsJobItem: 'Agencja celna',
      DepotJobItem: 'Depot',
      FreightJobItem: 'Armator',
      FreightMaintenanceJobItem: 'Armator',
      InsuranceJobItem: 'Ubezpieczyciel',
      TerminalJobItem: 'Terminal',
      TransportJobItem: 'Przewoźnik',
      OtherJobItem: 'Kontrahent',
    },
    services: {
      createItem: 'Dodaj usługę',
      tabTitle: 'Usługi',
      activity: 'Usługa',
      unit: 'Jednostka',
      price: 'Cena',
      customsAgency: 'Agencja celna',
      shippingLine: 'Armator',
      insurer: 'Ubezpieczyciel',
      trucker: 'Przewoźnik',
      otherFunction: 'Usługa',
      relatedLoads: 'Ładunki',
      door: 'Cel',
      agent: 'Agent',
      billOfLadingNumber: 'B/L',
      estimatedDelivery: 'TT',
      valueAmount: 'Wartość ładunku',
      insuranceRate: 'Stawka ‰',
      multiplyFactor: 'Przelicznik',
      driver: 'Kierowca',
      driverName: 'Nazwisko kierowcy',
      driverEmail: 'Email',
      driverPhone: 'Telefon kierowcy',
      driverDocumentNumber: 'Dowód osobisty kierowcy',
      vehicleRegistrationNumber: 'Numer rejestracyjny ciężarówki',
      trailerRegistrationNumber: 'Numer rejestracyjny naczepy',
      trailerNumber: 'Numer naczepy',
      fromOffer: 'Usługa z oferty',
      route: 'Trasa',
      shipName: 'Nazwa statku',
      tripNumber: 'Numer podróży',
      cutOff: 'Cut off',
      ETD: 'ETD',
      loadingPort: 'Port załadunku',
      ETA: 'ETA',
      loadDate: 'Data załadunku',
      unloadDate: 'Data rozładunku',
      executionDate: 'Data wykonania',
      unloadingPort: 'Port wyładunku',
      showPriceTag: 'Pokaż cenę',
      hidePriceTag: 'Ukryj cenę',
      customsClearance: 'Miejsce odprawy celnej',
      additionalRemarks: 'Uwagi dodatkowe',
      insuranceDescription: '%1‰ z %2% wartości ładunku',
      exchangeRate: 'Kurs wymiany {currency}',
      customsClearances: {
        noClearance: 'Brak',
        other: 'Inne',
        IMPORT: {
          done: 'Odprawiono',
          inProgress: 'Tranzyt',
        },
        EXPORT: {
          done: 'W zakładzie',
          inProgress: 'W porcie',
        },
        // FIXME: need name for these
        COUNTRY: {
          done: '?',
          inProgress: '?',
        },
      },
      doorDate: {
        IMPORT: 'Data podjęcia',
        EXPORT: 'Data dostawy',
      },
    },
    documents: {
      tabTitle: 'Dokumenty',
      types: {
        blData: 'Dane B/L',
        waybill: 'Listy przewozowe',
        transportOrder: 'Zlecenia transportowe',
        notification: 'Awizacje',
        acceptanceConfirmation: 'Potwierdzenie przyjęcia zlecenia',
        shippingInstructions: 'Instrukcje przewozowe',
        customsMessages: 'Dokumenty celne',
      },
      job: 'Spedycja',
      jobEntry: 'Ładunek',
      documentNumber: 'Numer dokumentu',
      generationDate: 'Data wygenerowania',
      sendDate: 'Data wysłania',
      documentsWarnings: {
        withoutFreight: 'Aby wygenerować document, musisz dodać usługę frachtu',
      },
      filename: 'Nazwa pliku',
      containerNo: 'Numer kontenera',
      receiveDate: 'Data odebrania',
    },
    events: {
      tabTitle: 'Zdarzenia',
      sectionTitle: 'Zdarzenia',
      note: 'Notatka',
      mail: 'E-mail',
      attachment: 'Załącznik',
      mailSent: ' została wysłana.',
      defaultMessage: 'Dokument został wysłany.',
    },
    communications: {
      tabTitle: 'Komunikacja',
      shippingLines: 'Armatorzy',
      terminals: 'Terminale',
      trackAndTrace: 'Track&Trace',
      sendNotification: 'Wyślij awizację',
      containerNotificationSent:
        'Wysłano awizację dla kontenera {containerNumber}',
      status: {
        NOT_SENT: 'Nie wysłany',
        SENT: 'Wysłany',
        REJECTED: 'Odrzucony',
        ACKNOWLEDGED: 'Odebrany',
        CANCELLED: 'Anulowany',
        TECH_REJECTED: 'Odrzucony tech.',
        CONFIRMED: 'Potwierdzony',
        UPDATED: 'Zaktualizowany',
      },
      carriageCondition: {
        label: 'Carriage condition',
        DOOR_TO_DOOR: 'Door to Door',
        DOOR_TO_PIER: 'Door to Pier',
        PIER_TO_DOOR: 'Pier to Door',
        PIER_TO_PIER: 'Pier to Pier',
      },
      cargoTypes: {
        AWKWARD: 'Awkward',
        DANGEROUS: 'Dangerous',
        GENERAL: 'General',
        REEFER: 'Reefer',
        AWKWARD_DANGEROUS: 'Awkward dangerous',
        REEFER_DANGEROUS: 'Reefer dangerous',
      },
      bookingRequest: {
        title: 'Booking Request',
        documentNumber: 'Numer dokumentu',
        bookingNumber: 'Booking number',
        generationDate: 'Data wygenerowania',
        status: 'Status',
        dateOfSending: 'Data wysłania',
        receiver: 'Odbiorca bookingu',
        details: 'Szczegóły',
        new: 'Nowy',
        pickup: 'Pick-up',
        placeOfPickup: 'Pickup',
        loading: 'Miejsce załadunku',
        discharge: 'Miejsce wyładunku',
        delivery: 'Miejsce dostawy',
        earliestDeparture: 'Najwcześniejsza data wypłynięcia',
        ultimateDeparture: 'Ostateczna data wypłynięcia',
        earliestArrival: 'Najwcześniejsza data dopłynięcia',
        ultimateArrival: 'Ostateczna data dopłynięcia',
        dates: 'Daty bookingu',
        chooseDateType: 'Wybierz rodzaj daty',
        carriage: 'Warunki przewozu',
        referenceNumber: 'Numer referencyjny',
        inland: 'Śródlądowy',
        carrier: 'Przewoźnik',
        bookingParty: 'Strona bukingu',
        shipperParty: 'Wysyłający',
        generalRemark: 'Generalne uwagi',
        amendmentReason: 'Powód zmian',
        bookingRequestCancellation: 'Anulowanie Bukingu nr ',
        cancellationConfirmation: 'Czy na pewno chcesz anulować Buking nr ',
        cancellationReason: 'Powód anulowania',
        receiverLabels: {
          CMA: 'CMA',
          MAERSK: 'Maersk',
          INTTRA: 'Inttra',
        },
        referenceNumberLabels: referenceNumberLabels,
        partyLabels: {
          CONSIGNEE: 'Odbiorca',
          FORWARDER: 'Spedytor',
        },
        typeOfCargo: 'Rodzaj ładunku',
        goodsDescription: 'Opis ładunku',
        handling: 'Warunki',
        handlingLabels: {
          OFU: 'Fumigacja',
          OOD: 'Przechowywać na pokładzie',
          OSB: 'Przechowywać pod pokładem',
        },
        productGroup: 'Grupa produktów',
        containers: 'Kontenery',
        temperature: 'Temperatura',
        measurements: 'Measurements',
        dimensions: 'Wymiary ładunku',
        instructionLabels: {
          HANDLING_INSTRUCTIONS: 'Instrukcje przewozowe',
          CONTAINER_ATMOSPHERE: 'Instrukcje dot. powietrza',
          CO2_PERCENTAGE: 'procent CO2',
          O2_PERCENTAGE: 'procent O2',
          SENSETIVE_CARGO: 'Transport wrażliwy',
          HUMIDITY_PERCENTAGE: 'Procent wilgotności',
          PRE_COOLING: 'Schładzenie wstępne',
          GENERATOR_SET: 'Informacje o agregacie',
        },
        instructions: 'Wybierz funkcje strony',
        packingGroupLabels: {
          I: 'Niskie niebezpieczeństwo',
          II: 'Średnie niebezpieczeństwo',
          III: 'Duże niebezpieczeństwo',
          GREAT_DANGER: 'Duże niebezpieczeństwo',
          MEDIUM_DANGER: 'Średnie niebezpieczeństwo',
          MINOR_DANGER: 'Niskie niebezpieczeństwo',
        },
        packingGroup: 'Grupa pakowana',
        remarks: 'Dodatkowe uwagi',
        imdg: 'Informacje dot. ładunków niebezpiecznych',
        remarksLabels: {
          REMARKS_OF_WHOLE_BOOKING: 'Uwagi do bookingu',
          EXPORT_DECLARATION: 'Deklaracja eksportowa (Kanada)',
          REEFER_CARGO_INBOUND_CONTACT: 'Chłodnie przychodzące-kontakt',
          REEFER_OUTBOUND_CONTACT: 'Chłodnie wychodzące-kontakt',
          REEFER_REMARKS: 'Uwagi do chłodni',
          CUSTOMS_CLEARANCE_INSTRUCTIONS: 'Odprawa celna',
          CUSTOMS_DECLARATION_INFORMATION: 'Deklaracja celna',
        },
        remarksValueCode: {
          CUSTOMER_TO_PERFORM_AMS_FILING: 'Customer to perform ams filing',
          CANADIAN_CARGO_CONTROL_NUMBER: 'Canadian cargo control number',
          NVOCC_SCAC: 'NVOCC SCAC',
          CUSTOMS_EXPORT_DECLARATION_UNIQUE_CONSIGNMENT_REFERENCE:
            'Customs export declaration unique consignment reference',
        },
        customsClearanceInstructionsValueCodeLabel:
          'Customs clearance instructions type',
        customsDeclarationInformationValueCodeLabel:
          'Customs declaration information type',
        customValidation: {
          carriageCondition: 'Wybierz warunki przewozu.',
          seaportMissing: 'Uzupełnij kod portu w tabeli portów',
        },
        cargoTypeDescription: 'Uwagi dot. rodzaju ładunku',
        hsCode: 'HS code',
        shippersOwnedContainer: 'Właściciel kontenera',
        requestedFullPickupDate: 'Wymagana data odbioru',
        requestedEmptyPositioningDate: 'Data podstawienia pustego kontenera',
        fieldsValidation: {
          measurementType: measurements.GROSS_WEIGHT + ' musi być uzupełniona',
          measurementValue: measurements.GROSS_WEIGHT + ' musi być uzupełniona',
          referenceNumberType:
            referenceNumberLabels.FREIGHT_TARIFF_REFERENCE +
            ' lub ' +
            referenceNumberLabels.SERVICE_CONTRACT +
            ' musi być uzupełnione',
          referenceNumber:
            referenceNumberLabels.FREIGHT_TARIFF_REFERENCE +
            ' lub ' +
            referenceNumberLabels.SERVICE_CONTRACT +
            ' musi być uzupełnione',
          mutuallyExclusiveReferenceNumbers:
            'Uzupełniono wykluczające się pola ' +
            referenceNumberLabels.FREIGHT_TARIFF_REFERENCE +
            ' oraz ' +
            referenceNumberLabels.SERVICE_CONTRACT +
            '. Należy uzupełnić tylko jedno z pól',
          requestedEmptyPositioningDate:
            'Data podstawienia pustego kontenera musi być uzupełniona jeżeli Move Type ma wartość Door to Door lub Door to Port',
          requestedFullPickupDate:
            'Wymagana data odbioru musi być uzupełniona jeżeli Move Type ma wartość Door to Door lub Door to Port',
          shippersOwnedContainer:
            'Pole właściciel kontenera musi być wypełnione',
        },
        shippersOwnedContainerLabels: {
          SHIPPER: 'Załadowca',
          CARRIER: 'Armator',
        },
      },
      shippingInstruction: {
        title: 'Shipping Instruction',
        shippingNumber: 'Numer instrukcji przewozowej',
        sendingDate: 'Data wysłania',
        generationDate: 'Data wygenerowania',
        status: 'Shipping instruction status',
        receiver: 'Receiver',
        bookingNumber: 'Booking number',
        bookingNumberRequired: 'Please enter booking number.',
        carriageConditionRequired: 'Please choose carriage condition.',
        amendmentReason: 'Powód zmian',
        notificationEmailSendNeed: 'Chcę otrzymywać powiadomienia e-mail',
        updateShippingInstruction: 'Zaktualizuj shipping instruction',
        chargePayment: {
          label: 'Charge payment instructions',
          COLLECT: 'Collect',
          MIXED: 'Mixed',
          PREPAID: 'Prepaid',
        },
        chargeCategory: {
          label: 'Charges category',
          ALL_CHARGES: 'All charges',
          BASIC_FREIGHT: 'Basic freight',
          DESTINATION_HAULAGE_CHARGES: 'Destination haulage charges',
          DESTINATION_PORT_CHARGES: 'Destination port charges',
          ORIGIN_PORT_CHARGES: 'Origin port charges',
          ORIGIN_HAULAGE_CHARGES: 'Origin haulage charges',
          OTHER_CHARGES: 'Other charges',
          ORIGIN: 'Origin',
          DESTINATION: 'Destination',
        },
        chargePaymentRequired: 'Please choose payment instructions.',
        document: 'Document',
        documentType: {
          hint: 'Wybierz typ',
          BILL_OF_LADING: 'Bill of lading',
          BILL_OF_LADING_COPY: 'Bill of lading copy',
          SEA_WAYBILL: 'Sea waybill',
          MARINE_TRANSPORT_DOCUMENT:
            'Non-negotiable maritime transport document (generic) / Express',
          HOUSE_BILL_OF_LADING: 'House bill of lading / Memo BL',
          HOUSE_WAYBILL: 'House waybill',
          BILL_OF_LADING_ORIGINAL: 'Bill of lading original',
        },
        documentStatus: {
          hint: 'Status',
          NOT_FREIGHTED: 'Not freighted',
          FREIGHTED: 'Freighted',
        },
        documentMedium: {
          hint: 'Sposób transmisji',
          CARGOSMART_ONLINE_BL: 'CargoSmart Online BL',
          EDI_TRANSMISSION: 'EDI transmission',
          ELECTRONIC_MAIL: 'Electronic mail',
          TELEFAX: 'Telefax',
          MAIL_PRINTED_ORIGINAL_REQUIRED: 'Mail (Printed Original Required)',
          OTHERS: 'Others',
        },
        documentCopies: 'Liczba kopii',
        documentOriginals: 'Liczba oryginałów',
        documentName: 'Nazwa dokumentu',
        parties: 'Parties',
        partyType: {
          SUBMITTER: 'SI Submitter',
          CARRIER: 'Carrier',
          CONSIGNEE: 'Consignee',
          SHIPPER: 'Shipper',
          FORWARDER: 'Freight forwarder',
          EXPORTER: 'Exporter',
          GOODS_OWNER: 'Goods owner',
          NOTIFY_PARTY_1: 'Notify party no. 1',
          NOTIFY_PARTY_2: 'Notify party no. 2',
          NOTIFY_PARTY_3: 'Notify party no. 3',
        },
        party: 'Strona',
        partyName: 'Nazwa',
        voyage: 'Voyage',
        voyageStage: 'Voyage stage',
        voyageNumber: 'Voyage number',
        vesselName: 'Vessel name',
        governmentReference: 'Government reference number',
        placeOfPickup: 'Place of receipt',
        placeOfLoading: 'Place of loading',
        placeOfDischarge: 'Place of discharge',
        placeOfDelivery: 'Place of delivery',
        inland: 'Inland location',
        goods: 'Cargo details',
        commodity: 'Commodity',
        cargoTypeHint: 'Rodzaj ładunku',
        cargoTypeLabel: 'Cargo type',
        applyCargoDetails: 'Apply details',
        applyCargoDetailsTo: {
          label: 'Specify and apply to all containers',
          ALL: 'All cargo details',
          PIECES: 'Piece count only',
          DESCRIPTION: 'Cargo description only',
          NONE: 'No, I specify all details at container level',
        },
        packages: 'Packages',
        numberOfPackages: 'Number of packages',
        packageTypeHint: 'Kind of packages',
        packageType: {
          AMPOULE_NON_PROTECTED: 'Ampoule, non-protected',
          AMPOULE_PROTECTED: 'Ampoule, protected',
          BAG: 'Bag',
          BAG_FLEXIBLE_CONTAINER: 'Bag, flexible container',
          BAG_LARGE: 'Bag, large',
          BAG_MULTIPLY: 'Bag, multiply',
          BAG_PAPER: 'Bag, paper',
          BAG_PAPER_MULTI_WALL: 'Bag, paper, multi-wall',
          BAG_PAPER_MULTI_WALL_WATER_RESISTANT:
            'Bag, paper, multi-wall, water resistant',
          BAG_PLASTIC: 'Bag, plastic',
          BAG_PLASTICS_FILM: 'Bag, plastics film',
          BAG_SUPER_BULK: 'Bag, super bulk',
          BAG_TEXTILE: 'Bag, textile',
          BAG_TEXTILE_SIFT_PROOF: 'Bag, textile, sift proof',
          BAG_TEXTILE_WATER_RESISTANT: 'Bag, textile, water resistant',
          BAG_TEXTILE_WITHOUT_INNER_COAT_LINER:
            'Bag, textile, without inner coat/liner',
          BAG_WOVEN_PLASTIC: 'Bag, woven plastic',
          BAG_WOVEN_PLASTIC_SIFT_PROOF: 'Bag, woven plastic, sift proof',
          BAG_WOVEN_PLASTIC_WATER_RESISTANT:
            'Bag, woven plastic, water resistant',
          BAG_WOVEN_PLASTIC_WITHOUT_INNER_COAT_LINER:
            'Bag, woven plastic, without inner coat/liner',
          BALE_COMPRESSED: 'Bale, compressed',
          BALE_NON_COMPRESSED: 'Bale, non-compressed',
          BAR: 'Bar',
          BARREL: 'Barrel',
          BARREL_WOODEN: 'Barrel, wooden',
          BARREL_WOODEN_BUNG_TYPE: 'Barrel, wooden, bung type',
          BARREL_WOODEN_REMOVABLE_HEAD: 'Barrel, wooden, removable head',
          BARS_IN_BUNDLE_BUNCH_TRUSS: 'Bars, in bundle/bunch/truss',
          BASKET: 'Basket',
          BASKET_WITH_HANDLE_CARDBOARD: 'Basket, with handle, cardboard',
          BASKET_WITH_HANDLE_PLASTIC: 'Basket, with handle, plastic',
          BASKET_WITH_HANDLE_WOODEN: 'Basket, with handle, wooden',
          BIN: 'Bin',
          BLOCK: 'Block',
          BOBBIN: 'Bobbin',
          BOTTLECRATE_BOTTLERACK: 'Bottlecrate / bottlerack',
          BOTTLE_GAS: 'Bottle, gas',
          BOTTLE_NON_PROTECTED_BULBOUS: 'Bottle, non-protected, bulbous',
          BOTTLE_NON_PROTECTED_CYLINDRICAL:
            'Bottle, non-protected, cylindrical',
          BOTTLE_PROTECTED_BULBOUS: 'Bottle, protected bulbous',
          BOTTLE_PROTECTED_CYLINDRICAL: 'Bottle, protected cylindrical',
          BOX: 'Box',
          BOX_ALUMINIUM: 'Box, aluminium',
          BOX_COMMONWEALTH_HANDLING_EQUIPMENT_POOLCHEP_EUROBOX:
            'Box, Commonwealth Handling Equipment Pool(CHEP), Eurobox',
          BOX_FIBREBOARD: 'Box, fibreboard',
          BOX_FOR_LIQUIDS: 'Box, for liquids',
          BOX_NATURAL_WOOD: 'Box, natural wood',
          BOX_PLASTIC: 'Box, plastic',
          BOX_PLASTIC_EXPANDED: 'Box, plastic, expanded',
          BOX_PLASTIC_SOLID: 'Box, plastic, solid',
          BOX_PLYWOOD: 'Box, plywood',
          BOX_RECONSTITUTED_WOOD: 'Box, reconstituted wood',
          BOX_STEEL: 'Box, steel',
          BOX_WOODEN_NATURAL_WOOD_ORDINARY:
            'Box, wooden, natural wood, ordinary',
          BOX_WOODEN_NATURAL_WOOD_WITH_SIFT_PROOF_WALLS:
            'Box, wooden, natural wood, with sift proof walls',
          BUCKET: 'Bucket',
          BULK_GAS_AT_1031_MBAR_AND_15C: 'Bulk, gas(at 1031 mbar and 15Â°C)',
          BULK_LIQUEFIED_GAS_AT_ABNORMAL_TEMPERATURE_PRESSURE:
            'Bulk, liquefied gas(at abnormal temperature/pressure)',
          BULK_LIQUID: 'Bulk, liquid',
          BULK_SOLID_FINE_PARTICLES_POWDERS:
            'Bulk, solid, fine particles(â€œpowdersâ€)',
          BULK_SOLID_GRANULAR_PARTICLES_GRAINS:
            'Bulk, solid, granular particles(â€œgrainsâ€)',
          BULK_SOLID_LARGE_PARTICLES_NODULES:
            'Bulk, solid, large particles(â€œnodulesâ€)',
          BUNCH: 'Bunch',
          BUNDLE: 'Bundle',
          CAGE: 'Cage',
          CAGE_COMMONWEALTH_HANDLING_EQUIPMENT_POOLCHEP:
            'Cage, Commonwealth Handling Equipment Pool (CHEP)',
          CAGE_ROLL: 'Cage, roll',
          CANISTER: 'Canister',
          CAN_CYLINDRICAL: 'Can, cylindrical',
          CAN_RECTANGULAR: 'Can, rectangular',
          CAN_WITH_HANDLE_AND_SPOUT: 'Can, with handle and spout',
          CARBOY_NON_PROTECTED: 'Carboy, non-protected',
          CARBOY_PROTECTED: 'Carboy, protected',
          CARTON: 'Carton',
          CASE: 'Case',
          CASE_ISOTHERMIC: 'Case, isothermic',
          CASE_SKELETON: 'Case, skeleton',
          CASE_STEEL: 'Case, steel',
          CASE_WITH_PALLET_BASE: 'Case, with pallet base',
          CASE_WITH_PALLET_BASE_CARDBOARD: 'Case, with pallet base, cardboard',
          CASE_WITH_PALLET_BASE_METAL: 'Case, with pallet base, metal',
          CASE_WITH_PALLET_BASE_PLASTIC: 'Case, with pallet base, plastic',
          CASE_WITH_PALLET_BASE_WOODEN: 'Case, with pallet base, wooden',
          CASK: 'Cask',
          CHEST: 'Chest',
          CHURN: 'Churn',
          COFFER: 'Coffer',
          COFFIN: 'Coffin',
          COIL: 'Coil',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE:
            'Composite packaging, glass receptacle',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_ALUMINIUM_CRATE:
            'Composite packaging, glass receptacle in aluminium crate',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_ALUMINIUM_DRUM:
            'Composite packaging, glass receptacle in aluminium drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_EXPANDABLE_PLASTIC_PACK:
            'Composite packaging, glass receptacle in expandable plastic pack',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_FIBREBOARD_BOX:
            'Composite packaging, glass receptacle in fibreboard box',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_FIBRE_DRUM:
            'Composite packaging, glass receptacle in fibre drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_PLYWOOD_DRUM:
            'Composite packaging, glass receptacle in plywood drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_SOLID_PLASTIC_PACK:
            'Composite packaging, glass receptacle in solid plastic pack',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_STEEL_CRATE_BOX:
            'Composite packaging, glass receptacle in steel crate box',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_STEEL_DRUM:
            'Composite packaging, glass receptacle in steel drum',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_WICKERWORK_HAMPER:
            'Composite packaging, glass receptacle in wickerwork hamper',
          COMPOSITE_PACKAGING_GLASS_RECEPTACLE_IN_WOODEN_BOX:
            'Composite packaging, glass receptacle in wooden box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE:
            'Composite packaging, plastic receptacle',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_ALUMINIUM_CRATE:
            'Composite packaging, plastic receptacle in aluminium crate',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_ALUMINIUM_DRUM:
            'Composite packaging, plastic receptacle in aluminium drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_FIBREBOARD_BOX:
            'Composite packaging, plastic receptacle in fibreboard box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_FIBRE_DRUM:
            'Composite packaging, plastic receptacle in fibre drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_PLASTIC_DRUM:
            'Composite packaging, plastic receptacle in plastic drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_PLYWOOD_BOX:
            'Composite packaging, plastic receptacle in plywood box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_PLYWOOD_DRUM:
            'Composite packaging, plastic receptacle in plywood drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_SOLID_PLASTIC_BOX:
            'Composite packaging, plastic receptacle in solid plastic box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_STEEL_CRATE_BOX:
            'Composite packaging, plastic receptacle in steel crate box',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_STEEL_DRUM:
            'Composite packaging, plastic receptacle in steel drum',
          COMPOSITE_PACKAGING_PLASTIC_RECEPTACLE_IN_WOODEN_BOX:
            'Composite packaging, plastic receptacle in wooden box',
          CONE: 'Cone',
          CONTAINER_NOT_OTHERWISE_SPECIFIED_AS_TRANSPORT_EQUIPMENT:
            'Container, not otherwise specified as transport equipment',
          CRATE: 'Crate',
          CRATE_BEER: 'Crate, beer',
          CRATE_BULK_CARDBOARD: 'Crate, bulk, cardboard',
          CRATE_BULK_PLASTIC: 'Crate, bulk, plastic',
          CRATE_BULK_WOODEN: 'Crate, bulk, wooden',
          CRATE_FRAMED: 'Crate, framed',
          CRATE_FRUIT: 'Crate, fruit',
          CRATE_MILK: 'Crate, milk',
          CRATE_MULTIPLE_LAYER_CARDBOARD: 'Crate, multiple layer, cardboard',
          CRATE_MULTIPLE_LAYER_PLASTIC: 'Crate, multiple layer, plastic',
          CRATE_MULTIPLE_LAYER_WOODEN: 'Crate, multiple layer, wooden',
          CRATE_SHALLOW: 'Crate, shallow',
          CREEL: 'Creel',
          CYLINDER: 'Cylinder',
          DRUM: 'Drum',
          DRUM_ALUMINIUM: 'Drum, aluminium',
          DRUM_ALUMINIUM_NON_REMOVABLE_HEAD:
            'Drum, aluminium, non-removable head',
          DRUM_ALUMINIUM_REMOVABLE_HEAD: 'Drum, aluminium, removable head',
          DRUM_FIBRE: 'Drum, fibre',
          DRUM_IRON: 'Drum, iron',
          DRUM_PLASTIC: 'Drum, plastic',
          DRUM_PLASTIC_NON_REMOVABLE_HEAD: 'Drum, plastic, non-removable head',
          DRUM_PLASTIC_REMOVABLE_HEAD: 'Drum, plastic, removable head',
          DRUM_PLYWOOD: 'Drum, plywood',
          DRUM_STEEL: 'Drum, steel',
          DRUM_STEEL_NON_REMOVABLE_HEAD: 'Drum, steel, non-removable head',
          DRUM_STEEL_REMOVABLE_HEAD: 'Drum, steel, removable head',
          DRUM_WOODEN: 'Drum, wooden',
          ENVELOPE: 'Envelope',
          ENVELOPE_STEEL: 'Envelope, steel',
          FILMPACK: 'Filmpack',
          FLASK: 'Flask',
          FRAME: 'Frame',
          HAMPER: 'Hamper',
          HOGSHEAD: 'Hogshead',
          INTERMEDIATE_BULK_CONTAINER: 'Intermediate bulk container',
          INTERMEDIATE_BULK_CONTAINER_ALUMINIUM:
            'Intermediate bulk container, aluminium',
          INTERMEDIATE_BULK_CONTAINER_ALUMINIUM_LIQUID:
            'Intermediate bulk container, aluminium, liquid',
          INTERMEDIATE_BULK_CONTAINER_ALUMINIUM_PRESSURISED_10_KPA:
            'Intermediate bulk container, aluminium, pressurised > 10 kpa',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE:
            'Intermediate bulk container, composite',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_FLEXIBLE_PLASTIC_LIQUIDS:
            'Intermediate bulk container, composite, flexible plastic, liquids',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_FLEXIBLE_PLASTIC_PRESSURISED:
            'Intermediate bulk container, composite, flexible plastic, pressurised',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_FLEXIBLE_PLASTIC_SOLIDS:
            'Intermediate bulk container, composite, flexible plastic, solids',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_RIGID_PLASTIC_LIQUIDS:
            'Intermediate bulk container, composite, rigid plastic, liquids',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_RIGID_PLASTIC_PRESSURISED:
            'Intermediate bulk container, composite, rigid plastic, pressurised',
          INTERMEDIATE_BULK_CONTAINER_COMPOSITE_RIGID_PLASTIC_SOLIDS:
            'Intermediate bulk container, composite, rigid plastic, solids',
          INTERMEDIATE_BULK_CONTAINER_FIBREBOARD:
            'Intermediate bulk container, fibreboard',
          INTERMEDIATE_BULK_CONTAINER_FLEXIBLE:
            'Intermediate bulk container, flexible',
          INTERMEDIATE_BULK_CONTAINER_METAL:
            'Intermediate bulk container, metal',
          INTERMEDIATE_BULK_CONTAINER_METAL_LIQUID:
            'Intermediate bulk container, metal, liquid',
          INTERMEDIATE_BULK_CONTAINER_METAL_OTHER_THAN_STEEL:
            'Intermediate bulk container, metal, other than steel',
          INTERMEDIATE_BULK_CONTAINER_METAL_PRESSURE_10_KPA:
            'Intermediate bulk container, metal, pressure 10 kpa',
          INTERMEDIATE_BULK_CONTAINER_NATURAL_WOOD:
            'Intermediate bulk container, natural wood',
          INTERMEDIATE_BULK_CONTAINER_NATURAL_WOOD_WITH_INNER_LINER:
            'Intermediate bulk container, natural wood, with inner liner',
          INTERMEDIATE_BULK_CONTAINER_PAPER_MULTI_WALL:
            'Intermediate bulk container, paper, multi-wall',
          INTERMEDIATE_BULK_CONTAINER_PAPER_MULTI_WALL_WATER_RESISTANT:
            'Intermediate bulk container, paper, multi-wall, water resistant',
          INTERMEDIATE_BULK_CONTAINER_PLASTIC_FILM:
            'Intermediate bulk container, plastic film',
          INTERMEDIATE_BULK_CONTAINER_PLYWOOD:
            'Intermediate bulk container, plywood',
          INTERMEDIATE_BULK_CONTAINER_PLYWOOD_WITH_INNER_LINER:
            'Intermediate bulk container, plywood, with inner liner',
          INTERMEDIATE_BULK_CONTAINER_RECONSTITUTED_WOOD:
            'Intermediate bulk container, reconstituted wood',
          INTERMEDIATE_BULK_CONTAINER_RECONSTITUTED_WOOD_WITH_INNER_LINER:
            'Intermediate bulk container, reconstituted wood, with inner liner',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC:
            'Intermediate bulk container, rigid plastic',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_FREESTANDING_LIQUIDS:
            'Intermediate bulk container, rigid plastic, freestanding, liquids',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_FREESTANDING_PRESSURISED:
            'Intermediate bulk container, rigid plastic, freestanding, pressurised',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_FREESTANDING_SOLIDS:
            'Intermediate bulk container, rigid plastic, freestanding, solids',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_WITH_STRUCTURAL_EQUIPMENT_LIQUIDS:
            'Intermediate bulk container, rigid plastic, with structural equipment, liquids',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_WITH_STRUCTURAL_EQUIPMENT_PRESSURISED:
            'Intermediate bulk container, rigid plastic, with structural equipment, pressurised',
          INTERMEDIATE_BULK_CONTAINER_RIGID_PLASTIC_WITH_STRUCTURAL_EQUIPMENT_SOLIDS:
            'Intermediate bulk container, rigid plastic, with structural equipment, solids',
          INTERMEDIATE_BULK_CONTAINER_STEEL:
            'Intermediate bulk container, steel',
          INTERMEDIATE_BULK_CONTAINER_STEEL_LIQUID:
            'Intermediate bulk container, steel, liquid',
          INTERMEDIATE_BULK_CONTAINER_STEEL_PRESSURISED_10_KPA:
            'Intermediate bulk container, steel, pressurised > 10 kpa',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_COATED:
            'Intermediate bulk container, textile, coated',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_COATED_AND_LINER:
            'Intermediate bulk container, textile, coated and liner',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_WITH_LINER:
            'Intermediate bulk container, textile, with liner',
          INTERMEDIATE_BULK_CONTAINER_TEXTILE_WITH_OUT_COAT_LINER:
            'Intermediate bulk container, textile with out coat/liner',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_COATED:
            'Intermediate bulk container, woven plastic, coated',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_COATED_AND_LINER:
            'Intermediate bulk container, woven plastic, coated and liner',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_WITHOUT_COAT_LINER:
            'Intermediate bulk container, woven plastic, without coat/liner',
          INTERMEDIATE_BULK_CONTAINER_WOVEN_PLASTIC_WITH_LINER:
            'Intermediate bulk container, woven plastic, with liner',
          JAR: 'Jar',
          JERRICAN_CYLINDRICAL: 'Jerrican, cylindrical',
          JERRICAN_PLASTIC: 'Jerrican, plastic',
          JERRICAN_PLASTIC_NON_REMOVABLE_HEAD:
            'Jerrican, plastic, non-removable head',
          JERRICAN_PLASTIC_REMOVABLE_HEAD: 'Jerrican, plastic, removable head',
          JERRICAN_RECTANGULAR: 'Jerrican, rectangular',
          JERRICAN_STEEL: 'Jerrican, steel',
          JERRICAN_STEEL_NON_REMOVABLE_HEAD:
            'Jerrican, steel, non-removable head',
          JERRICAN_STEEL_REMOVABLE_HEAD: 'Jerrican, steel, removable head',
          JUG: 'Jug',
          JUTEBAG: 'Jutebag',
          KEG: 'Keg',
          LIFTVAN: 'Liftvan',
          MUTUALLY_DEFINED: 'Mutually defined',
          NEST: 'Nest',
          NET: 'Net',
          NET_TUBE_PLASTIC: 'Net, tube, plastic',
          NET_TUBE_TEXTILE: 'Net, tube, textile',
          PACKAGE: 'Package',
          PACKAGE_CARDBOARD_WITH_BOTTLE_GRIP_HOLES:
            'Package, cardboard, with bottle grip-holes',
          PACKAGE_DISPLAY_CARDBOARD: 'Package, display, cardboard',
          PACKAGE_DISPLAY_METAL: 'Package, display, metal',
          PACKAGE_DISPLAY_PLASTIC: 'Package, display, plastic',
          PACKAGE_DISPLAY_WOODEN: 'Package, display, wooden',
          PACKAGE_FLOW: 'Package, flow',
          PACKAGE_PAPER_WRAPPED: 'Package, paper wrapped',
          PACKAGE_SHOW: 'Package, show',
          PACKET: 'Packet',
          PAIL: 'Pail',
          PALLET: 'Pallet',
          PALLET_100CMS_110CMS: 'Pallet, 100cms * 110cms',
          PALLET_BOX_COMBINED_OPEN_ENDED_BOX_AND_PALLET:
            'Pallet, box Combined open-ended box and pallet',
          PALLET_MODULAR_COLLARS_80CMS_100CMS:
            'Pallet, modular, collars 80cms * 100cms',
          PALLET_MODULAR_COLLARS_80CMS_120CMS:
            'Pallet, modular, collars 80cms * 120cms',
          PALLET_MODULAR_COLLARS_80CMS_60CMS:
            'Pallet, modular, collars 80cms * 60cms',
          PALLET_SHRINKWRAPPED: 'Pallet, shrinkwrapped',
          PIECE: 'Piece',
          PIPE: 'Pipe',
          PIPES_IN_BUNDLE_BUNCH_TRUSS: 'Pipes, in bundle/bunch/truss',
          PITCHER: 'Pitcher',
          POT: 'Pot',
          POUCH: 'Pouch',
          RACK: 'Rack',
          RACK_CLOTHING_HANGER: 'Rack, clothing hanger',
          RECEPTACLE_FIBRE: 'Receptacle, fibre',
          RECEPTACLE_GLASS: 'Receptacle, glass',
          RECEPTACLE_METAL: 'Receptacle, metal',
          RECEPTACLE_PAPER: 'Receptacle, paper',
          RECEPTACLE_PLASTIC: 'Receptacle, plastic',
          RECEPTACLE_PLASTIC_WRAPPED: 'Receptacle, plastic wrapped',
          RECEPTACLE_WOODEN: 'Receptacle, wooden',
          REEL: 'Reel',
          RING: 'Ring',
          ROLL: 'Roll',
          SACHET: 'Sachet',
          SACK: 'Sack',
          SACK_MULTI_WALL: 'Sack, multi-wall',
          SEA_CHEST: 'Sea-chest',
          SET: 'Set',
          SHEET: 'Sheet',
          SHEETS_IN_BUNDLE_BUNCH_TRUSS: 'Sheets, in bundle/bunch/truss',
          SHEET_PLASTIC_WRAPPING: 'Sheet, plastic wrapping',
          SHRINKWRAPPED: 'Shrinkwrapped',
          SKID: 'Skid',
          SPINDLE: 'Spindle',
          SPOOL: 'Spool',
          TANK_CYLINDRICAL: 'Tank, cylindrical',
          TANK_RECTANGULAR: 'Tank, rectangular',
          TIN: 'Tin',
          TRAY: 'Tray',
          TRAY_CONTAINING_HORIZONTALLY_STACKED_FLAT_ITEMS:
            'Tray, containing horizontally stacked flat items',
          TRAY_ONE_LAYER_NO_COVER_CARDBOARD:
            'Tray, one layer no cover, cardboard',
          TRAY_ONE_LAYER_NO_COVER_PLASTIC: 'Tray, one layer no cover, plastic',
          TRAY_ONE_LAYER_NO_COVER_POLYSTYRENE:
            'Tray, one layer no cover, polystyrene',
          TRAY_ONE_LAYER_NO_COVER_WOODEN: 'Tray, one layer no cover, wooden',
          TRAY_RIGID_LIDDED_STACKABLE_CEN_TS_14482_2002:
            'Tray, rigid, lidded stackable(CEN TS 14482:2002)',
          TRAY_TWO_LAYERS_NO_COVER_CARDBOARD:
            'Tray, two layers no cover, cardboard',
          TRAY_TWO_LAYERS_NO_COVER_PLASTIC_TRAY:
            'Tray, two layers no cover, plastic tray',
          TRAY_TWO_LAYERS_NO_COVER_WOODEN: 'Tray, two layers no cover, wooden',
          TRUNK: 'Trunk',
          TRUSS: 'Truss',
          TUB: 'Tub',
          TUBE: 'Tube',
          TUBES_IN_BUNDLE_BUNCH_TRUSS: 'Tubes, in bundle/bunch/truss',
          TUBE_COLLAPSIBLE: 'Tube, collapsible',
          TUBE_WITH_NOZZLE: 'Tube, with nozzle',
          TUB_WITH_LID: 'Tub, with lid',
          TUN: 'Tun',
          UNIT: 'Unit',
          UNPACKED_OR_UNPACKAGED: 'Unpacked or unpackaged',
          UNPACKED_OR_UNPACKAGED_MULTIPLE_UNITS:
            'Unpacked or unpackaged, multiple units',
          UNPACKED_OR_UNPACKAGED_SINGLE_UNIT:
            'Unpacked or unpackaged, single unit',
          VANPACK: 'Vanpack',
          VAT: 'Vat',
          VEHICLE: 'Vehicle',
          VIAL: 'Vial',
        },
        grossWeight: 'Weight (kg)',
        grossVolume: 'Volume (m^3)',
        cargoDescription: 'Cargo description',
        dimensions: 'Dimensions',
        length: 'Długość',
        width: 'Szerokość',
        height: 'Wysokość',
        dimensionUnit: 'Jednostka',
        hsCode: 'HS code',
        IMDGCode: 'IMDG code',
        IMOCCodeHint: 'IMO class',
        IMDGCodeHint: 'Kod',
        DGSCode: 'Dangerous goods description',
        DGSName: 'Dangerous goods contact name',
        DGSPhone: 'Dangerous goods contact phone',
        flashpoint: 'Flashpoint',
        temperatureHint: 'Temperature',
        flashUnit: 'Unit',
        packingGroup: 'Packing group',
        shippingMarks: 'Shipping marks',
        containers: 'Container list',
        containerNumberHint: 'Choose container',
        measurements: measurements,
        seals: {
          label: 'Seals',
          issuers: {
            CARRIER: 'Carrier',
            CONSGINEE: 'Consignee',
            CUSTOMS: 'Customs',
            FORWARDER: 'Forwarder',
            HIGH_SECURITY: 'High Security',
            MOTOR_CARRIER: 'Motor Carrier',
            NOTIFY_PARTY: 'Notify Party',
            QUARANTINE_AGENCY: 'Quarantine agency',
            RAILROAD: 'Railroad',
            SHIPPER: 'Shipper',
            TERMINAL_OPERATOR: 'Terminal operator',
            VET_SEAL: 'Vet Seal',
            MUTUALLY_DEFINED: 'Mutually Defined',
          },
        },
        sealIssuerHint: 'Wystawiający',
        sealNumberHint: 'Numer plomby',
        temperature: 'Temperature',
        additionalInformation: 'Additional information',
        total: 'Total',
        totalGrossWeight: 'Total gross weight',
        totalConsignment: 'Total consignment, cube',
        totalPackages: 'Total number of packages',
        totalEquipment: 'Total number of equipment',
        remarks: 'Remarks, Clauses',
        remarkCodes: {
          hint: 'Wybierz kod',
          DO_NOT_PRINT_ANY_CHARGES_IN_BL: 'Do not print any charges in B/L',
          SHIPPERS_LOAD_AND_COUNT: "Shipper's Load and Count",
          SHIPPERS_LOAD_STOWAGE_AND_COUNT: "Shipper's Load, Stowage and Count",
          LADEN_ON_BOARD: 'Laden on Board',
          LADEN_ON_BOARD_VESSEL: 'Laden on Board Vessel',
          VESSEL_NOT_RESPONSIBLE_FOR_FREEZING:
            'Vessel Not Responsible for Freezing',
          CONTAINER_SEALED_BY_SHIPPER: 'Container(s) Sealed by Shipper',
          ON_DECK_AT_SHIPPERS_RISK: "On Deck at Shipper's Risk",
          SHORT_SHIPPED: 'Short-Shipped',
          SEA_WAYBILL: 'Sea Waybill',
          THIS_SHIPMENT_IS_EFFECTED_UNDER_A_SEA_WAYBILL:
            'This Shipment is Effected under a Sea Waybill',
          MEMO_BILL_OF_LADING_ONLY: 'Memo Bill of Lading Only',
          REFRIGERATED_CARGO: 'Refrigerated Cargo',
          COOL_CARGO: 'Cool Cargo',
          FREEZE_CARGO: 'Freeze Cargo',
          INLAND_TRANSPORTATION_ARRANGED_AS_AGENTS:
            'Inland Transportation Arranged as Agents Only with such Arranged Transportation Being Solely for Account and Risk of Cargo',
          SEA_AIR_CARGO: 'Sea-Air Cargo',
          FREIGHT_PREPAID: 'Freight Prepaid',
          FREIGHT_COLLECT: 'Freight Collect',
          FREIGHT_AS_AGREED: 'Freight as Agreed',
          NO_SHIPPERS_EXPORT_DECLARATION_REQUIRED:
            "No Shipper's Export Declaration Required (Section 30.39)",
          CARRIER_HEATED_WAREHOUSE_AT_COST:
            'Carrier Reserves the Right to Place Container(s) in Heated Warehouse at a Set Cost',
          ON_BOARD_RAIL: 'On Board Rail',
          ON_BOARD_TRUCK: 'On Board Truck',
          ON_BOARD_VESSEL: 'On Board Vessel',
          RECEIVED_FOR_SHIPMENT: 'Received For Shipment',
          ON_BOARD_CONTAINER: 'On Board Container',
          EMERGENCY_RESPONSE_STATEMENT: 'Emergency Response Statement',
          INTERNATIONAL_MARITIME_ORGANIZATION_CERTIFICATION:
            'International Maritime Organization Certification',
          DESTINATION_CONTROL_STATEMENTS: 'Destination Control Statements',
          PRODUCING_COUNTRY_OF_ORIGIN: 'Producing Country of Origin',
          LADEN_ON_BOARD_NAMED_VESSEL: 'Laden on Board Named Vessel',
          AGE_OF_VESSEL: 'Age of Vessel',
          CERTIFICATION_STATEMENTS: 'Certification Statements',
          DESTINATION_COUNTRY: 'Destination Country',
          TITLE_PASSAGE_CLAUSE: 'Title Passage Clause',
          CONTAINER_SAFETY_ACT: 'Container Safety Act',
          GENERAL_AGREEMENT_ON_TARIFF_AND_TRADE:
            'General Agreement on Tariff and Trade (GATT)',
          PRIOR_DAMAGE_REMARKS: 'Prior Damage Remarks',
          ADMINISTRATIVE: 'Administrative',
          CARIBBEAN_BASIN_INITIATIVE: 'Caribbean Basin Initiative (CBI)',
          CUSTOM: 'Custom',
          CONTAINER_PACKING_CERTIFICATE: 'Container Packing Certificate',
          DISCLAIMER: 'Disclaimer',
          DELIVERY_ORDER_LIABILITY_CLAUSE: 'Delivery Order Liability Clause',
          ESTIMATE_ERROR: 'Estimate Error',
          ESTIMATE_REMARKS: 'Estimate Remarks',
          GENERAL_SYSTEM_OF_PREFERENCES: 'General System of Preferences (GSP)',
          HEADING: 'Heading',
          HIDDEN: 'Hidden',
          ISRAELI_FREE_TRADE_AGREEMENT: 'Israeli Free Trade Agreement',
          NORTH_AMERICAN_FREE_TRADE_AGREEMENT:
            'North American Free Trade Agreement (NAFTA)',
        },
        BLRemarks: 'Bill of lading remarks',
        BLClauses: 'Bill of lading clauses',
        specialInstructions: 'Special instructions',
        alert: {
          messageSent:
            'Instrukcje przewozowe numer {documentNumber}/SI/{updateCounter} wysłane do armatora.',
          messageNotSent:
            'Instrukcje przewozowe numer {documentNumber}/SI/{updateCounter} nie zostały wysłane do armatora.',
        },
        measurementValue: 'Niepoprawna wartość',
      },
      bookingConfirmation: {
        title: 'Booking Confirmation',
        carrier: 'Carrier',
        bookingParty: 'Booking party',
        shipperParty: 'Shipper',
        consigneeParty: 'Consignee',
        forwarderParty: 'Forwarder',
        containers: 'Containers',
        bookingNumber: 'Booking number',
        inttraReference: 'Inttra ref.',
        bookingConfirmationStatus: 'Booking Confirmation status',
        carriageCondition: 'Carriage condition',
        category: 'Category',
        shippingInstructionsCutoff: 'Shipping Instructions cutoff',
        vgmCutoff: 'VGM cutoff',
        generalInformation: 'General information',
        status: {
          CONFIRMED: 'confirmed',
          CANCELLED: 'Cancelled',
          REJECTED_BY_CARRIER: 'Rejected by Carrier',
          UPDATED: 'Last updated on ',
        },
        categoryLabels: {
          LCLLCL: 'LCL/LCL',
          FCLFCL: 'FCL/FCL',
          FCLLCL: 'FCL/LCL',
          LCLFCL: 'LCL/FCL',
        },
        transportStagesHeader: 'Transport stages',
        transportStageQualifier: {
          PRE_CARRIAGE_TRANSPORT: 'Pre-carriage transport',
          MAIN_CARRIAGE_TRANSPORT: 'Main carriage (first)',
          MAIN_CARRIAGE_TRANSPORT_SECOND: 'Main carriage (second)',
          MAIN_CARRIAGE_TRANSPORT_THIRD: 'Main carriage (third)',
          MAIN_CARRIAGE_TRANSPORT_FOURTH: 'Main carriage (fourth)',
          MAIN_CARRIAGE_TRANSPORT_FIFTH: 'Main carriage (fifth)',
          ON_CARRIAGE_TRANSPORT: 'On-carriage transport',
        },
        transportStage: {
          ordinalNumber: 'Transport stage',
          qualifier: 'Transport stage qualifier',
          voyageNumber: 'Voyage number',
          carrier: 'Carrier',
          transportId: 'Transport ID',
          vesselName: 'Vessel name',
          placeOfPickup: 'Place of pick-up',
          cutOffDate: 'Cut-off',
          pickupDate: 'Pick-up date',
          placeOfLoading: 'Place of loading',
          etd: 'ETD',
          placeOfDischarge: 'Place of discharge',
          eta: 'ETA',
          placeOfDelivery: 'Place of delivery',
          deliveryDate: 'Delivery date',
        },
        bookingPartiesHeader: 'Booking parties',
        goodsDescription: 'Goods description',
        cargoType: 'Cargo type',
        containersHeader: 'Containers',
        containerSupplier: {
          Carrier: 'Carrier supplied',
          Shipper: 'Shipper supplied',
        },
        latestDeliveryDate: 'Cutoff',
        emptyContainerPickupLocation: 'Empty container pickup location',
        fullContainerDropOffLocation: 'Full container dropoff location',
      },
      verificationOfMass: {
        showModalButton: 'Deklaruj wagę',
        missingBookingNumber: 'Wprowadź numer bukingu by deklarować wagę.',
        contactOperatorToDeclareWeight:
          'Skontaktuj się ze spedytorem w celu zadeklarowania wagi.',
        missingContainerNumber: 'Wprowadź numer kontenera by deklarować wagę.',
        header: 'Deklaracja zweryfikowanej masy kontenera',
        warning:
          'Oświadczam, że podana przeze mnie waga VGM określona została zgodnie z przepisami Konwencji SOLAS.',
        shipper: 'Wysyłający',
        personResponsible: 'Osoba odpowiedzialna',
        containerWeight: 'Waga kontenera (kg)',
        verificationDate: 'Data weryfikacji',
        verificationMethods: {
          label: 'Metoda weryfikacji',
          method1: 'Ważenie kontenera (SM1)',
          method2: 'Ważenie paczek (SM2)',
          hint:
            'Metoda 1 (SM1) -  Ważenie pełnego kontenera przy użyciu wagi najazdowej.\n' +
            'Metoda 2 (SM2) - Ważenie załadowanych paczek, palet itd. Należy doliczyć wagę kontenera!',
        },
        messageSent:
          'Zweryfikowana waga brutto dla {containers} wysłana do armatora',
        messageNotSent:
          'Zweryfikowana waga brutto dla {containers} nie została wysłana do armatora',
      },
    },
  },
  counterparty: {
    counterparty: 'Kontrahent',
    details: 'Profil kontrahenta',
    name: 'Nazwa',
    code: 'Nazwa skrócona',
    description: 'Opis',
    tradeKeepers: 'Opiekunowie handlowi',
    taxTypes: {
      NIP: 'NIP',
      VATIN: 'VATIN',
      OTHER: 'Inny',
    },
    cad: 'CAD',
    nip: 'NIP',
    regon: 'REGON',
    krs: 'KRS',
    TaxIdentificator: 'Identyfikator podatkowy',
    IdentificatorCode: 'Kod identyfikatora',
    data: 'Dane kontrahenta',
    businessCards: 'Wizytówki',
    addBusinessCard: 'Dodaj wizytówkę',
    accounts: 'Konta bankowe',
    addAccount: 'Dodaj konto',
    EU: 'EU',
    defaultInvoiceClass: 'Domyślny typ faktury',
    redirectToActivityList: 'Przekieruj do pełnej listy aktywności',
    tabs: {
      general: 'Informacje',
      files: 'Pliki',
      upcoming: 'Nadchodzące aktywności',
      latest: 'Ostatnie aktywności',
      serviceTerms: 'OWŚU',
    },
    files: {
      name: 'Nazwa',
      label: 'Etykieta',
      creationDate: 'Data dodania',
      createFile: 'Dodaj plik',
      createServiceTermsFile: 'Dodaj OWŚU',
      serviceTermFilesNotSet:
        'Plik OWSU dla danego kontrahenta nie został uzupełniony.',
    },
  },
  businessFunctions: {
    functions: {
      Trucker: 'Przewoźnik',
      Customer: 'Klient',
      CustomsAgency: 'Agencja celna',
      Insurer: 'Ubezpieczyciel',
      Depot: 'Depot',
      ShippingLine: 'Armator',
      Terminal: 'Terminal',
      Other: 'Inne',
      Agent: 'Agent',
    },
    trucker: {
      sectionName: 'Przewoźnik',
      licenseExpiration: 'Data ważności licencji',
      insuranceExpiration: 'Ubezpieczony do',
      insuranceAmount: 'Wartość ubezpieczenia',
    },
    customer: {
      sectionName: 'Klient',
      jobKeepers: 'Opiekunowie spedycyjni',
      storehouses: 'Magazyny',
      addStorehouse: 'Dodaj magazyn',
      dueDays: 'Terminy płatności',
      defaultCurrency: 'Domyślna waluta',
      defaultProductGroup: 'Grupa produktów',
      editStorehouses: 'Edytuj magazyny',
      saveStoreHouses: 'Zapisz magazyny',
    },
    customsAgency: {
      sectionName: 'Agencja celna',
    },
    insurer: {
      sectionName: 'Ubezpieczyciel',
    },
    depot: {
      sectionName: 'Depot',
      addLot: 'Dodaj plac',
      port: 'Port',
      editLots: 'Edytuj place',
      saveLots: 'Zapisz place',
    },
    shippingline: {
      sectionName: 'Armator',
      scac: 'SCAC',
      contractNumber: 'Numer kontraktu',
    },
    terminal: {
      sectionName: 'Terminal',
      port: 'Port',
    },
    other: {
      sectionName: 'Inne',
    },
    agent: {
      sectionName: 'Agent',
    },
  },
  user: {
    details: 'Profil użytkownika',
    data: 'Dane użytkownika',
    name: 'Nazwa',
    login: 'Login',
    phone: 'Telefon',
    email: 'E-mail',
    role: 'Stanowisko',
    account: 'Status konta',
    enabled: 'Aktywne',
    locked: 'Zawieszone',
    accountExpired: 'Data wygaśnięcia konta',
    credentialsExpired: 'Hasło wygasłe',
    memberships: 'Przynależność',
    permissions: {
      sectionName: 'Uprawnienia',
      group: 'Grupa ról',
      roles: 'Role',
    },
    branch: 'Oddział',
    currentPassword: 'Aktualne hasło',
    password: 'Hasło',
    passwordRepeat: 'Powtórz hasło',
    passwordsDontMatch: 'Hasła nie są identyczne',
    emailCredentials: 'Ustawienia email',
    emailLogin: 'Konto email',
    emailPassword: 'Hasło email',
    emailCredentialsChanged: 'Ustawienia email zostały pomyślnie zmienione',
    replacements: 'Zastępstwa',
    clientPanel: 'Konto panelu klienta',
    customer: 'Klient',
    acceptedBothAcceptances: 'Wyrażone zgody RODO',
  },
  resource: {
    labels: {
      OFFER_TEMPLATE: 'Szablon wydruku oferty',
      INVOICE_TEMPLATE: 'Szablon wydruku faktury',
    },
    lastModifiedTime: 'Data modyfikacji',
    creationTime: 'Data utworzenia',
    size: 'Rozmiar pliku',
  },
  parameter: {
    labels: {
      DEFAULT_EXCHANGE_RATE_SOURCE: 'Domyślne źródło kursów walut',
      PRIMARY_CURRENCY_CODE: 'Główna waluta',
      PRIMARY_COUNTERPARTY_CODE: 'Główny kontrahent',
      TRUCKER_LICENSE_EXPIRED_MESSAGE:
        'Komunikat o wygaśnięciu licencji przewoźnika',
      TRUCKER_INSURANCE_EXPIRED_MESSAGE:
        'Komunikat o wygaśnięciu ubezpieczenia przewoźnika',
      OFFER_CODE_FORMAT: 'Format numeracji ofert',
      JOB_CODE_FORMAT: 'Format numeracji spedycji',
      WAYBILL_CODE_GENERATOR: 'Format numeracji listów przewozowych',
      INVOICE_CODE_GENERATOR: 'Format numeracji faktur',
      CORRECTIVE_INVOICE_CODE_GENERATOR: 'Format numeracji faktur korygującuch',
      NO_VAT_INVOICE_CODE_GENERATOR: 'Format numeracji faktur NP',
      NO_VAT_CORRECTIVE_INVOICE_CODE_GENERATOR:
        'Format numeracji faktur korygujących NP',
      PRIMARY_CONTROLLER: 'Główny kontroler',
      USER_PASSWORD_EXPIRE_DAYS: 'Liczba dni ważności hasła użytkownika',
      ORDER_CODE_GENERATOR: 'Format kodu zleceń',
      REQUEST_FOR_OFFER_CODE_FORMAT: 'Format kodu zapytań ofertowych',
      SHIPPING_INSTRUCTION_CODE_FORMAT: 'Format kodu instrukcji przewozowych',
      BOOKING_REQUEST_CODE_FORMAT: 'Format kodu bukingów',
      DEFAULT_TAX_RATE: 'Domyślna stawka podatku',
      LAST_CONSECUTION_RESET_YEAR:
        'Rok ostatniego uruchomienia resetu liczników',
      ADMINISTRATIVE_INVOICE_CODE_GENERATOR:
        'Format numeracji faktur administracyjnych',
      CORRECTIVE_ADMINISTRATIVE_INVOICE_CODE_GENERATOR:
        'Format numeracji faktur administracyjnych korygujących',
      CUT_OFF_TIME:
        'Ostrzegaj o nieopublikowanych fakturach starszych niż (godziny)',
      ALERT_EXPIRE_DAYS: 'Liczba dni po których zostaną usunięte powiadomienia',
      ARCHIVED_EDI_MESSAGE_DELETE_AFTER_DAYS:
        'Liczba dni po których zostaną usunięte zapisane wychodzące komunikaty EDI',
      PRIMARY_COUNTERPARTY_LOCATION_UNECE_CODE:
        'Kod UNECE lokalizacji głównego kontrahenta',
    },
    parameter: 'Parametr',
  },
  group: {
    details: 'Profil grupy',
    data: 'Dane grupy',
    roles: 'Role grupy',
    code: 'Nazwa',
    description: 'Opis',
  },
  branch: {
    path: 'Ścieżka dziedziczenia',
    parent: 'Oddział wyżej',
    branches: 'Oddziały',
  },
  port: {
    details: 'Profil portu',
    data: 'Dane portu',
    name: 'Nazwa',
    description: 'Opis',
    countryCode: 'Kraj',
    seaportCode: 'Kod portu',
    main: 'Główny',
  },
  currency: {
    currency: 'Waluta',
    addCurrency: 'Dodaj walutę',
    visible: 'Widoczna',
  },
  activity: {
    serviceType: 'Rodzaj',
    discriminant: 'Wyróżnik',
    tradeType: 'Relacja',
    name: 'Nazwa',
    addLanguage: 'Dodaj język',
    tradeTypeLabels: {
      IMPORT: 'Import',
      EXPORT: 'Eksport',
      COUNTRY: 'Kraj',
    },
    loadType: 'Kategoria',
    granular: 'Ziarnistość',
    loadTypeLabels: {
      FCL: 'FCL',
      LCL: 'LCL',
      FTL: 'FTL',
      LTL: 'LTL',
    },
    direct: 'Bezpośrednia',
    incomeAccount: 'Konto przychodowe',
    costAccount: 'Konto kosztowe',
    billingAccount: 'Konto rozliczeniowe',
    transportMeansSell: 'Sprzedaż środka transportu',
  },
  unit: {
    addLanguage: 'Dodaj język',
    name: 'Nazwa',
  },
  clause: {
    initial: 'Użyj domyślnie',
    document: 'Dokument docelowy',
    documentLabels: {
      OFFER: 'Oferta',
      INVOICE: 'Faktura',
      WAYBILL_EXPORT: 'List przewozowy - eksport',
      WAYBILL_IMPORT: 'List przewozowy - import',
      CONTAINER_ORDER: 'Zlecenie złożenia/podjęcia',
      ADMINISTRATIVE_INVOICE: 'Faktura administracyjna',
      ACCEPTANCE_CONFIRMATION: 'Potwierdzenie przyjęcia zlecenia',
    },
    type: 'Typ',
    typeLabels: {
      BODY: 'Klauzula',
      HEADER: 'Nagłówek',
    },
    clause: 'Klauzula',
    header: 'Nagłówki',
    body: 'Klauzule',
    mandatory: 'Obowiązkowy',
    content: 'Treść',
    addLanguage: 'Dodaj język',
  },
  messages: {
    statusNotFound: 'Obiekt nie istnieje.',
    permissionDenied: 'Nie masz odpowiednich uprawnień.',
  },
  admin: {
    account: 'Konto',
    users: 'Użytkownicy',
    groups: 'Grupy',
    roles: 'Role',
    parameters: 'Parametry',
    branches: 'Oddziały',
    ports: 'Porty',
    units: 'Jednostki',
    activities: 'Usługi spedycyjne',
    currencies: 'Kody walut',
    productGroups: 'Grupy produktów',
    terminalPrices: 'Cenniki Terminali',
    customsAgencyPrices: 'Cenniki Agencji Celnych',
    transportPrices: 'Cenniki transportu',
    transportRates: 'Stawki transportowe',
    exchangeRates: 'Kursy wymiany',
    taxRates: 'Stawki VAT',
    packages: 'Opakowania',
    clauses: 'Klauzule',
    distances: 'Odległości',
    itemConfigurations: 'Konfiguracja',
    containerSizes: 'Rozmiary kontenerów',
    containerTypes: 'Typy kontenerów',
    invoiceClasses: 'Rodzaje faktur',
    containers: 'Kontenery',
    regions: 'Regiony',
    forecasts: 'Prognozy',
    transportModes: 'Rodzaje transportu',
    ediParties: 'Odbiorcy',
    jpk: 'JPK',
    generateJpk: 'Wygeneruj plik JPK',
    primaryCounterpartyData: 'Dane głównego kontrahenta',
    generateJpkSuccess: 'Liczba pobranych plików: {count}',
    serviceTerms: 'OWŚU',
    inttraSupportedLines: 'Armatorzy INTTRA',
    inttraIntegration: 'Integracja z INTTRA',
  },
  superadmin: {
    initialDataLoad: 'Ładowanie danych', // TODO: better label?
    clearData: 'Usuń istniejące dane',
    loadData: 'Załaduj dane',
    activityMapping: ' - wyróżniki',
  },
  tabs: {
    truckers: 'Przewoźnicy',
    customers: 'Klienci',
    counterparties: 'Kontrahenci',
    customsagencies: 'Agencje celne',
    insurers: 'Ubezpieczyciele',
    depots: 'Depoty',
    shippinglines: 'Armatorzy',
    terminals: 'Terminale',
    others: 'Inni',
    agents: 'Agenci',
  },
  menu: {
    offers: 'Oferty',
    jobs: 'Spedycje',
    folders: 'Teczki',
    invoices: 'Faktury',
    rates: 'Stawki',
    transportCloud: 'Chmura transportowa',
    reports: 'Raporty i prognozy',
    files: 'Kartoteka',
    counterparties: 'Kontrahenci',
    tables: 'Tabele',
    prices: 'Cenniki',
    inbox: 'Wiadomości',
    administration: 'Administracja',
    superadmin: 'Super admin panel',
    account: 'Moje konto',
    logout: 'Wyloguj się',
    settings: 'Ustawienia',
    inquiries: 'Zapytania',
    orders: 'Zlecenia',
    newsletter: 'Newsletter',
    client: 'Klient',
    mapping: 'Mapowanie',
  },
  clientHomePage: {
    notifications: 'Wiadomości',
  },
  homePage: {
    notifications: 'Powiadomienia',
    dashboard: 'Pulpit',
  },
  businessCard: {
    name: 'Imię i nazwisko',
    description: 'Opis',
    function: 'Stanowisko',
    email: 'E-mail',
    phone: 'Telefon',
    phone2: 'Komórka',
    fax: 'Faks',
    other: 'Inne',
  },
  responsibilities: {
    responsibilities: 'Funkcje',
    CustomsMessageReceiver: 'Odbiorca dokumentów celnych',
    InvoiceReceiver: 'Odbiorca faktur',
    OfferReceiver: 'Odbiorca ofert',
    ComplainmentReceiver: 'Odbiorca reklamacji',
    Other: 'Inna',
  },
  bankAccount: {
    number: 'Numer konta',
    swift: 'Numer SWIFT',
    bank: 'Bank',
  },
  validation: {
    required: 'To pole jest wymagane.',
    requiredObjectId: 'To pole jest wymagane.',
    dualFieldRequired: 'To pole jest wymagane.',
    min: 'Wprowadź liczbę większą lub równą {{0}}.',
    minFraction: 'Wprowadź liczbę większą lub równą {{0}}.',
    max: 'Wprowadź liczbę mniejszą lub równą {{0}}.',
    minLength: 'Wprowadź co najmniej {{0}} znaków.',
    maxLength: 'Wprowadź co najwyżej {{0}} znaków.',
    exactlLength: 'Wprowadź dokładnie {{0}} znaków.',
    maxValueLength: 'Wprowadź co najwyżej {{0}} cyfr.',
    pattern: 'Sprawdź to pole.',
    step: 'Wartość musi być wielokrotnością {{0}}.',
    email: 'Wprowadź poprawny adres e-mail.',
    date: 'Wprowadź poprawną datę.',
    dateISO: 'Wprowadź poprawną datę.',
    number: 'Wprowadź liczbę.',
    digit: 'Wprowadź cyfrę.',
    phoneUS: 'Wprowadź poprawny numer telefonu.',
    equal: 'Wartości muszą być równe.',
    notEqual: 'Wybierz inną wartość.',
    unique: 'Sprawdź czy wartość jest unikalna.',
    tarpaulinCode: 'Wprowadź pomiędzy 5 a 11 znaków.',
    containerCode: 'Wartość musi spełniać standard ISO6346.',
    greaterThan: 'Wprowadź liczbę większą niż {0}.',
    ISO6346: 'Wartość musi spełniać standard ISO6346.',
    noPastDates: 'Wprowadź datę z przyszłości.',
    filename:
      'Nazwa pliku nie może zawierać \\ / : * ? " < > | # lub zaczynać się od kropki.',
    minGross: 'Cena brutto musi być większa bądź równa {0}.',
    minWeight: 'Masa brutto musi być równa lub większa od Masy netto.',
    integer: 'Podaj liczbę całkowitą.',
    VATINNumber: 'Podaj prawidłowy NIP.',
    lengthObservable: 'Podaj dokładnie {0} znaków.',
    uploadField: 'Wybierz plik.',
    withoutLetters: 'Podaj wartość bez żadnych liter.',
    bigDecimal: 'Podaj liczbę mniejszą niż 10^17.',
    minArrayLength: 'Wybierz co najmniej {0} wartości.',
    notBeforeDependentDate: 'Proszę wprowadzić datę po {{0}}.',
    notBeforeDateAsync: 'Proszę wprowadzić datę po {{0}}.',
    notAfterDependentDate: 'Proszę wprowadzić datę przed {{0}}.',
    notEqualTo: 'Proszę wprowadzić wartość różną od {0}.',
    allocation: 'Wartość alokacji nie może przekraczać {0}.',
    noFutureDates: 'Wprowadź datę z przeszłości.',
    entryContainerTypeMismatch:
      'Uwaga! Wybrałeś usługi dotyczące innego rozmiaru kontenerów.',
    itemContainerTypeMismatch:
      'Uwaga! Wybrałeś ładunki o innym rozmiarze/typie niż zadeklarowany w usłudze.',
    exchangeRateDate: 'nie został znaleziony.',
    exchangeRateExistsAsync: 'Brak kursu wymiany dla {0} z dnia {1}.',
    allInUnitMismatch: 'Uwaga! Wybrałeś usługi dotyczące różnych jednostek.',
    REGONNumber: 'Podaj prawidłowy REGON.',
    postalCode: 'Podaj prawidłowy kod pocztowy.',
    toFirstDayOfCurrentMonth: 'pierwszym dniem bieżącego miesiąca',
    hasDuplicates: 'Istnieje duplikat tej wartości.',
    IBAN: 'Podaj prawidłowy kod IBAN',
    SWIFT: 'Podaj prawidłowy kod SWIFT',
    correctedInvoiceSelectedValidator: 'Wybierz istniejącą fakturę',
    allInMarkupChanged: 'Uwaga! Przeliczono marżę.',
  },
  datagrid: {
    of: 'z',
    placeholder: 'Szukaj',
    perPage: 'na stronę',
    entriesPerPage: 'Liczba wyników na stronę',
  },
  priceItem: {
    customsAgency: 'Agencja celna',
    terminal: 'Terminal',
    transport: 'Transport',
    currency: 'Waluta',
    netAmount: 'Cena netto',
    grossAmount: 'Cena brutto',
    markup: 'Marża',
    effectiveDate: 'Data ważności',
    activity: 'Usługa',
    containerSize: 'Rozmiar kontenera',
    containerType: 'Typ kontenera',
    fromLocation: 'Z',
    toLocation: 'Do',
    distance: 'Odległość',
    country: 'Kraj',
  },
  distance: {
    from: 'Z',
    to: 'Do',
    country: 'Kraj',
    distance: 'Odległość (km)',
    isNotUnique: 'Ten dystans nie jest unikalny',
  },
  transportRate: {
    from: 'Od (km)',
    to: 'Do (km)',
    isOverlapping: 'Dystanse się nakładają z innymi rekordami',
  },
  invoice: {
    invoice: 'Faktura',
    ownTab: 'Własne',
    foreignTab: 'Obce',
    administrativeTab: 'Administracyjne',
    internalTab: 'Wewnętrzne',
    own: 'Własna',
    correctiveInvoice: 'Faktura korekcyjna',
    forInvoice: 'Dla faktury',
    was: 'Było',
    shouldBe: 'Powinno być',
    issueDate: 'Data wystawienia',
    saleDate: 'Data sprzedaży',
    dueDate: 'Termin płatności',
    receiptDate: 'Data wpłynięcia',
    exchangeRateDate: 'Kurs z dnia',
    exchangeRateAlternateDate:
      'Brak kursu z dnia {{requestedDate}} dla {{currency}}, zostanie użyty kurs z {{foundDate}}',
    exchangeRateAlternateMultipleDate:
      'Brak kursów z dnia {requestedDate}, zostaną użyte kursy z {foundDate}',
    buyer: 'Nabywca',
    seller: 'Sprzedawca',
    ordinalNumber: '#',
    activity: 'Nazwa usługi',
    quantity: 'Ilość',
    logNumber: 'Numer dziennika',
    code: 'Numer faktury',
    exchangeRate: 'Kurs wymiany',
    price: 'Cena netto',
    unit: 'Jm',
    netValue: 'Wartość netto',
    taxRate: 'Stawka VAT',
    taxValue: 'Wartość VAT',
    grossValue: 'Wartość brutto',
    total: 'Razem',
    totalDifference: 'Razem różnica',
    including: 'w tym',
    addCorrective: 'Dodaj korektę',
    addAllocation: 'Dodaj alokację',
    allocation: 'Alokacja',
    updateAllocation: 'Zaktualizuj alokację',
    allocationInfo: 'Informacje o alokacji',
    allocations: 'Alokacje',
    allocationAmount: 'Kwota alokacji',
    allocationSum: 'Łączna kwota alokacji',
    allocationState: 'Stan alokacji',
    allocationActivity: 'Usługa',
    allocationSummaryCount: 'W tym:',
    allocationSummaryAmount: 'Na kwotę',
    allocationNoService: 'Pozostałe',
    invoiceType: 'Typ faktury',
    complaintReason: 'Powód reklamacji',
    rejectionReason: 'Powód odrzucenia',
    rejectionAcknowledgment: 'Zapoznałem się z powodem odrzucenia',
    rejectionAcknowledmentSuccess: 'Zapoznano się z powodem odrzucenia',
    addOwn: 'Dodaj własną',
    addForeign: 'Dodaj obcą',
    exportToFile: 'Eksportuj',
    markAsPaid: 'Rozlicz',
    allocatedAmount: 'Kwota zaalokowana',
    unallocatedAmount: 'Kwota niezaalokowana',
    invoiceAmount: 'Wartość faktury',
    exportDate: 'Data eksportu',
    publishSuccess: 'Faktura opublikowana',
    unpublishSuccess: 'Faktura nie jest opublikowana',
    paidSuccess: 'Status faktury zmieniony na "Zapłacona"',
    unpaidSuccess: 'Status faktury zmieniony na "Niezapłacona"',
    createInvoiceWarning: 'Wybrany typ nie jest obecnie obsługiwany',
    clearCorrectionRequired: 'Odrzuć reklamację',
    clearedRequiresCorrectionMark: 'Reklamacja faktury odrzucona.',
    unpublish: 'Cofnij publikację',
    stateFrom: 'Stan z dnia',
    issuer: 'Wystawca',
    np: 'NP',
    publicationDate: 'Data publikacji',
    originalExternalName: 'Oryginalna nazwa usługi',
    selectKeywords: 'Wskaż słowa kluczowe oryginalnej nazwy usługi',
    invoiceTypeLabels: {
      OWN: 'Własne',
      FOREIGN: 'Obce',
    },
    classTypes: {
      VAT: 'Faktura VAT',
      VAT_CORRECTIVE: 'Korekta VAT',
      ACCOUNT_NOTE: 'Nota księgowa',
      CORRECTION_NOTE: 'Nota korekcyjna',
      NO_VAT: 'NP',
      NO_VAT_CORRECTIVE: 'Korekta NP',
      ADMINISTRATIVE: 'Administracyjne',
      ADMINISTRATIVE_CORRECTIVE: 'Korekta administracyjne',
    },
    allocationStatusLabel: 'Status alokacji',
    allocationProgress: {
      ALL: 'Wszystkie',
      INITIAL: 'W trakcie',
      PARTIAL: 'Częściowo zaalokowana',
      FULL: 'Całkowicie zaalokowana',
      ACCEPTED: 'Alokacje zatwierdzone',
      FINALIZED: 'Po eksporcie',
      CANCELLED: 'Anulowana',
      COMPLAINED: 'Do reklamacji',
    },
    allocationStatus: {
      PENDING: 'Niezatwierdzona',
      ACCEPTED: 'Zatwierdzona',
      REJECTED: 'Odrzucona',
      REQUIRES_CORRECTION: 'Reklamowana',
    },
    goToInvoice: 'Idź do faktury',
    goToJob: 'Idź do spedycji',
    seeInSaldeo: 'Zobacz w Saldeo',
    accept: 'Zatwierdź alokację',
    invoiceStatus: {
      PAID: 'Zapłacona',
      NOT_PAID: 'Do zapłaty',
    },
    ksefStatus: 'Status KSeF',
    downloadUpo: 'Pobierz UPO',
    upoNotAvailableYet:
      'UPO nie jest jeszcze dostępne. Spróbuj ponownie później.',
    downloadUpoError: 'Nie udało się pobrać UPO. Spróbuj ponownie.',
    ksefRejectionReason: 'Powód odrzucenia',
    ksefReviewReason: 'Powód weryfikacji',
    openInKsef: 'Otwórz w KSeF',
    publishKsefSuccess: 'Faktura została wysłana do KSeF i opublikowana.',
    ksefErrorDetails: 'Szczegóły: {{details}}',
    ksefErrors: {
      KsefInvoicePublicationInProgress:
        'Wysyłka do KSeF trwa. Faktura nie jest jeszcze opublikowana. Sprawdź jej status za chwilę.',
      KsefInvoiceTransmissionInProgress:
        'KSeF przetwarza fakturę. Nie można jej teraz edytować ani anulować.',
      KsefInvoiceManualReviewRequired:
        'Faktura wymaga weryfikacji — nie ma pewności, czy KSeF ją odebrał. Nie wysyłaj jej ponownie. Skontaktuj się z utrzymaniem.',
      KsefFa3SchemaValidation:
        'Faktura nie przeszła walidacji KSeF (FA3). Popraw dane i opublikuj ją ponownie.',
      KsefInvoiceBusinessValidation:
        'Brakuje danych wymaganych przez KSeF. Uzupełnij je i opublikuj fakturę ponownie.',
      KsefZeroVatForForeignBuyer:
        'Stawka VAT 0% jest niedozwolona dla nabywcy spoza Polski. Zmień stawkę VAT lub dane kontrahenta.',
      KsefInvoiceRejected:
        'KSeF odrzucił fakturę. Popraw dane zgodnie z podaną przyczyną i opublikuj ją ponownie.',
      KsefInvoicePublicationTechnicalFailure:
        'Nie udało się wysłać faktury do KSeF z powodu problemu technicznego. Spróbuj ponownie za chwilę. Jeśli błąd się powtarza, skontaktuj się z utrzymaniem.',
      KsefInvoicePublicationFailed:
        'Faktura nie została opublikowana w KSeF. Popraw dane i opublikuj ją ponownie lub skontaktuj się z utrzymaniem.',
      BaseInvoiceMissingKsefNumber:
        'Faktura korygowana nie ma numeru KSeF. Najpierw ustal numer KSeF faktury pierwotnej, a potem wystaw korektę.',
      KsefQrLinkMissingForPrint:
        'Wydruk niedostępny. Faktura nie została jeszcze wysłana do KSeF. Opublikuj ją, aby wygenerować wydruk z kodem QR.',
    },
    publishToKsef: 'Wyślij do KSeF i publikuj {{language}}',
    publishKsefHeading: 'Wysyłka do KSeF i publikacja',
    publishKsefSummary: 'Po potwierdzeniu:',
    publishKsefSendTitle: 'Faktura trafi do KSeF',
    publishKsefSendDescription:
      'Dokument zostanie przesłany do Krajowego Systemu e-Faktur.',
    publishKsefPublishTitle: 'Faktura będzie widoczna w panelu klienta',
    publishKsefPublishDescription:
      'Po publikacji klient zobaczy fakturę w wersji {{language}}.',
    publishKsefEditTitle: 'Faktury nie będzie można edytować',
    publishKsefEditDescription:
      'Po publikacji nie będzie można zmieniać danych ani pozycji faktury.',
    ksefNumber: 'Numer KSeF',
    copyKsefNumber: 'Kopiuj numer KSeF:',
    ksefNumberCopied: 'Numer KSeF został skopiowany.',
    ksefNumberCopyError: 'Nie udało się skopiować numeru KSeF.',
    ksefState: {
      SENDING: 'Wysyłanie',
      ACCEPTED: 'Przyjęta ✅',
      REJECTED: 'Odrzucona',
      NEEDS_REVIEW: 'Wymaga weryfikacji',
    },
    invoicePublished: {
      label: 'Wszystkie',
      EXPORTED: 'Eksportowane',
      READY: 'Opublikowane',
      DRAFT: 'Nieopublikowane',
    },
    notPaid: 'Niezapłacona',
    paid: 'Zapłacona',
    unknownInvoiceMsg:
      'Wymaga przyporządkowania pozycji do wyróżnika przez zarządcę',
    allocationFailedMsg: 'Wymaga ręcznej alokacji',
    chooseLang: 'Wybierz język',
    cancelInvoiceHeading: 'Potwierdź anulowanie faktury',
    cancelInvoiceBody:
      'Czy na pewno chcesz anulować tę fakturę? Ta operacja nie może zostać cofnięta.',
    cancelInvoiceButton: 'Anuluj fakturę',
    markAllocationForCorrection: 'Reklamuj alokację',
    allocationMarkedForCorrection: 'Alokacja zareklamowana',
    unpublished: 'Nieopublikowane',
    withdraw: 'Odwołaj reklamację',
    correctionWithdrawn: 'Reklamacja odwołana',
    circulationLicenceDate: 'Data dopuszczenia do użytku',
    vehicleMileage: 'Przebieg pojazdu w km',
    vehicleHours: 'Liczba godzin roboczych',
    complaint: 'Reklamacja',
    createInvoice: 'Utwórz fakturę',
    fetchPartial:
      'Pobrano {{totalSaved}} z {{totalFound}} faktur. Sprawdź panel powiadomień nad tabelą, aby zobaczyć szczegóły.',
    fetchSuccess_one: 'Pomyślnie pobrano {{count}} fakturę.',
    fetchSuccess_few: 'Pomyślnie pobrano {{count}} faktury.',
    fetchSuccess_many: 'Pomyślnie pobrano {{count}} faktur.',
    noInvoicesFound: 'Brak nowych faktur do pobrania z {{systemFrom}}.',
    fetchAlreadyRunning:
      'Pobieranie faktur z {{systemFrom}} jest już w toku. Spróbuj ponownie później.',
    fetchTimeout:
      'Pobieranie faktur z {{systemFrom}} trwa dłużej niż oczekiwano. Sprawdź za chwilę - wyniki powinny wkrótce pojawić się w tabeli.',
    fetchError:
      'Wystąpił błąd komunikacji z {{systemWith}}. Spróbuj ponownie później.',
    enovaFetchSuccess:
      'Zaimportowano potwierdzenia z {{filesProcessed}} plików.',
    enovaFetchPartial:
      'Zaimportowano {{filesProcessed}} z {{filesFound}} plików. Sprawdź problematyczne rekordy / skontaktuj się z administracją.',
    enovaNoNewFiles: 'Nie znaleziono nowych plików do importu.',
    enovaFetchError:
      'Import już trwa lub wystąpił problem. Spróbuj ponownie / skontaktuj się z administracją.',
  },
  rates: {
    deleteRateSuccess: 'Stawka usunięta',
    deleteRateFailure: 'Wystąpił błąd podczas usuwania stawki',
    editSuccess: 'Stawka została edytowana',
    depublishSuccess: 'Publikacja stawki cofnięta',
    depublishFailure: 'Nie udało się cofnąć publikacji stawki',
    publicationSuccess: 'Stawka opublikowana',
    publicationFailure: 'Nie udało się opublikować stawki',
    depublish: 'Cofnij Publikację',
    published: 'Opublikowane',
    draft: 'Drafty',
    status: 'Status',
    save: 'Zapisz',
    publish: 'Publikuj',
    duplicate: 'Duplikuj',
    rate: 'Stawka',
    data: 'Dane',
    unit: 'Jednostka',
    cost: 'Koszt',
    currency: 'Waluta',
    publicationDateFrom: 'Od daty publikacji',
    publicationDateTo: 'Do daty publikacji',
    all: 'Wszystkie',
    onlyMine: 'Tylko moje',
    relation: 'Relacja',
    routeTooManyValidation: 'Dodano za dużo wartości',
    seaFreight: 'Fracht morski',
    rowsPerPageLabel: 'Liczba wyników na stronę',
    rateNumber: 'Numer stawki',
    dateFrom: 'Ważność od',
    dateTo: 'Ważność do',
    region: 'Region',
    activities: 'Usługi',
    publicationDate: 'Data publikacji',
    addRate: 'Dodaj stawkę',
    contractNumber: 'Numer kontraktu',
    tradeType: 'Relacja',
    shipowner: 'Armator',
    commodity: 'Commodity',
    namedAccount: 'NamedAccount',
    routeFrom: 'Trasa od',
    routeTo: 'Trasa do',
    containerType: 'Kontener',
    activity: 'Usługa',
    rateAllIn: 'Stawka all-in',
    expirationDateFrom: 'Data ważności od',
    expirationDateTo: 'Data ważności do',
    daysOff: 'Dni wolne',
    internalNote: 'Notatka wewnętrzna',
    addNewActivity: 'Dodaj nową usługę',
    removeActivity: 'Usuń',
    deleteRateHeading: 'Potwierdź usunięcie stawki',
    deleteRateBody:
      'Czy na pewno chcesz usunąć tę stawkę? Ta operacja nie może zostać cofnięta.',
    null: 'Brak',
    namedAccountValidationRules: 'Opcja Brak musi występować pojedynczo',
  },
  transportCloud: {
    table: {
      headers: {
        lp: 'Parametr',
        shippingLine: 'Armator',
        containerType: 'Rodzaj',
        customer: 'Klient',
        job: 'Spedycja',
        referenceNumbers: 'Nr Referencyjny',
        bookingNumber: 'Booking',
        pinCode: 'Pin',
        tradeType: 'Relacja',
        pickupLocation: 'Miejsce Podjęcia',
        pickupDate: 'Data Podjęcia',
        loadingDeliveryLocation: 'Załadunek / Dostawa',
        loadingDeliveryDate: 'Data Dostawy',
        deliveryLocation: 'Miejsce Złożenia',
        deliveryDate: 'Data Złożenia',
        customsClearance: 'Odprawa',
        weighing: 'Ważenie',
        productGroup: 'Ładunek',
        loadDescription: 'Opis Ładunku',
        comment: 'Uwagi',
        documents: 'Dokumenty',
        offerTruckerRate: 'Stawka Oferta',
        truckerRate: 'Stawka Przewoźnika',
        containerNumber: 'Numer Kontenera',
        triangulation: 'Triangulacja',
        containerStatus: 'Status Kontenera',
        trucker: 'Przewoźnik',
        driverName: 'Kierowca',
        driverDocumentNumber: 'Dow. Osobisty',
        driverPhone: 'Telefon',
        vehicleRegistrationNumber: 'Ciągnik',
        trailerRegistrationNumber: 'Naczepa',
        reportNotes: 'Raporty',
        actions: 'Akcje',
        shippingLineHaulage: 'Odwóz',
      },
      dayNames: {
        monday: 'Poniedziałek',
        tuesday: 'Wtorek',
        wednesday: 'Środa',
        thursday: 'Czwartek',
        friday: 'Piątek',
        saturday: 'Sobota',
        sunday: 'Niedziela',
        noLoadingDeliveryDate: 'Bez daty załadunku/dostawy',
      },
      statuses: {
        customsClearance: {
          none: 'Brak',
          import: {
            inProgress: 'Tranzyt',
            done: 'Odprawiono',
          },
          export: {
            inProgress: 'W porcie',
            done: 'W zakładzie',
          },
        },
        triangulation: {
          inApproval: 'W trakcie akceptacji',
          approved: 'Zaakceptowany ✅',
          none: 'Brak',
          depot: 'Z depotu',
        },
        weighing: {
          atLoading: 'Na załadunku',
          atPort: 'W porcie',
          otherAddress: 'Inny adres',
        },
      },
      validations: {
        containerNumber: 'Wartość musi spełniać standard ISO6346.',
        containerType: 'Typ kontenera jest wymagany.',
        loadingDeliveryDate:
          'Data dostawy musi być późniejsza niż data podjęcia oraz wcześniejsza niż data złożenia.',
        pickupDate:
          'Data podjęcia musi wcześniejsza niż data dostawy oraz data złożenia.',
        deliveryDate:
          'Data złożenia musi być późniejsza niż data podjęcia oraz data dostawy.',
        shippingLine: 'Armator jest wymagany.',
        truckerRateValue: 'Waluta jest wymagana gdy uzupełniono stawkę.',
        truckerRateCurrency: 'Stawka jest wymagana gdy uzupełniono walutę.',
        truckerRateNegative: 'Stawka nie może być ujemna.',
        referenceNumbers:
          'Każdy z numerów referencyjnych musi posiadać od 2 do 64 znaków.',
        comment: 'Uwagi nie mogą przekraczać 256 znaków.',
        bookingNumber: 'Numer bookingu nie może przekraczać 64 znaków.',
        driverName: 'Nazwisko kierowcy nie może przekraczać 40 znaków.',
        driverDocumentNumber:
          'Numer dowodu osobistego kierowcy nie może przekraczać 40 znaków.',
        driverPhone: 'Numer telefonu kierowcy nie może przekraczać 20 znaków.',
        vehicleRegistrationNumber:
          'Numer rejestracyjny ciężarówki nie może przekraczać 40 znaków.',
        trailerRegistrationNumber:
          'Numer rejestracyjny naczepy nie może przekraczać 40 znaków.',
        reportNotes: 'Raporty nie mogą przekraczać 256 znaków.',
        loadDescription: 'Opis ładunku nie może przekraczać 256 znaków.',
        pinCode: 'Numer pin musi posiadać od 2 do 64 znaków.',
      },
      required: {
        loadingDeliveryDate: 'Data dostawy jest wymagana.',
        pickupDate:
          'Data podjęcia jest wymagana w przypadku wpisów relacji IMPORT.',
        deliveryDate:
          'Data złożenia jest wymagana w przypadku wpisów relacji EXPORT.',
        loadingDeliveryLocation: 'Miejsce załadunku/dostawy jest wymagane.',
        pickupLocation:
          'Miejsce podjęcia jest wymagane w przypadku wpisów relacji IMPORT.',
        deliveryLocation:
          'Miejsce złożenia jest wymagane w przypadku wpisów relacji EXPORT.',
      },
      filters: {
        dateFrom: 'Od daty dostawy',
        dateTo: 'Do daty dostawy',
        onlyMine: 'Tylko moje',
      },
      buttons: {
        addEntry: 'Dodaj wpis transportowy',
        viewSettings: 'USTAWIENIA WIDOKU',
        save: 'Zapisz',
        cancel: 'Anuluj',
        delete: 'Usuń',
        yes: 'Tak',
        no: 'Nie',
        reload: 'Odśwież',
        accept: 'Akceptuj',
        send: 'Wyślij',
      },
      errors: {
        systemError: 'Wystąpił błąd systemu. Spróbuj ponownie.',
        capturedError:
          'Nie udało się zedytować tego pola, ponieważ ładunek jest po imporcie.',
        capturedEditDisabled:
          'Nie można edytować tego pola, ponieważ ładunek jest po imporcie.',
        elseModifiedError:
          'Ktoś inny zmodyfikował ten rekord w tym samym momencie. Spróbuj ponownie.',
        deleteError:
          'Wystąpił błąd podczas usuwania rekordów. Spróbuj ponownie.',
        deleteErrorDataIntegrityViolation:
          'Nie można usunąć wybranych rekordów, ponieważ co najmniej jeden z nich posiada aktywne powiązania w systemie.',
        importEditDisabled:
          'Nie można edytować tego pola dla ładunków relacji import.',
        exportEditDisabled:
          'Nie można edytować tego pola dla ładunków relacji eksport.',
        noPrivilegeEditDisabled: 'Nie masz uprawnień do edycji tej komórki.',
        noPrivilegeDeleteDisabled:
          'Próbujesz usunąć rekordy, do których usunięcia nie masz uprawnień.',
        noPrivilegeAddLoadDisabled:
          'Nie masz uprawnień do dodania ładunku do tej spedycji.',
        containerNumberError:
          'Kontener z tym numerem już został dodany do spedycji.',
        mailSenderNoPermission:
          'Nie masz uprawnień do wysyłania wiadomości e-mail.',
        mailSenderNoSelection: 'Wybierz co najmniej jeden rekord.',
        mailSenderNotAllJobRows:
          'Nie można wysłać rekordów będących wpisami transportowymi.',
        mailSenderNotSameJob:
          'Do wysłania można wybrać tylko rekordy należące do tej samej spedycji.',
        mailSenderNoTrucker:
          'Wszystkie wybrane rekordy muszą mieć uzupełnionego przewoźnika.',
        mailSenderNotOwner:
          'Możesz wysylać e-maile tylko dla własnych rekordów.',
        driverAddError:
          'Nie udało się dodać kierowcy do bazy danych. Spróbuj ponownie.',
        driverUpdateError:
          'Nie udało się zaktualizować kierowcy w bazie danych. Spróbuj ponownie.',
        driverDeleteErrorSingle:
          'Nie udało się usunąć kierowcy z bazy danych. Spróbuj ponownie.',
        driverDeleteErrorMultiple:
          'Nie udało się usunąć kierowców z bazy danych. Spróbuj ponownie.',
      },
      overlays: {
        dateChangeOverlay:
          'Zaproponowano zmianę daty dostawy tego rekordu na {{date}}. Naciśnij Akceptuj, aby potwierdzić zmianę.',
        dateChangeAcceptedOverlay:
          'Zmiana daty dostawy tego rekordu na {{date}} została już zaakceptowana. Odśwież stronę, aby zobaczyć aktualny widok.',
        deleteOverlay: 'Rekord został usunięty.',
      },
      dialogs: {
        multiEditingConfirmation:
          'Czy chcesz edytować pole dla wszystkich wybranych rekordów?',
        acceptMultiEditingConfirmation:
          'Czy chcesz zaakceptować tę zmianę daty dostawy dla wszystkich zaznaczonych rekordów?',
        multiEditingCheck: 'Odznacz rekordy po zapisaniu.',
        confirmDelete:
          'Czy na pewno chcesz usunąć wybrane rekordy? Ta operacja nie może zostać cofnięta.',
        viewSettingsHeader: 'Ustawienia widoku',
        mailSenderHeader: 'Nowa wiadomość - {{title}}',
        notificationLabel: 'Awizacja',
        notificationSuccessMessage: 'Pomyślnie wysłano awizację.',
        waybillLabel: 'List przewozowy',
        waybillSuccessMessage: 'Pomyślnie wysłano list przewozowy.',
        toLabel: 'Do',
        ccLabel: 'DW',
        bccLabel: 'UDW',
        subjectLabel: 'Temat',
        headingOneButton: 'Nagłówek H1',
        headingTwoButton: 'Nagłówek H2',
        headingThreeButton: 'Nagłówek H3',
        boldButton: 'Pogrubienie',
        italicButton: 'Kursywa',
        strikethroughButton: 'Przekreślenie',
        orderedListButton: 'Lista numerowana',
        bulletListButton: 'Lista punktowana',
        addRowBeforeButton: 'Wstaw wiersz powyżej',
        addRowAfterButton: 'Wstaw wiersz poniżej',
        deleteRowButton: 'Usuń wiersz',
        addColumnBeforeButton: 'Wstaw kolumnę po lewej',
        addColumnAfterButton: 'Wstaw kolumnę po prawej',
        deleteColumnButton: 'Usuń kolumnę',
        mergeCellsButton: 'Scal komórki',
        splitCellsButton: 'Podziel komórkę',
        cellBackgroundButton: 'Kolor tła',
        deleteTableButton: 'Usuń tabelę',
        notificationDisabledTooltip:
          'List przewozowy musi zostać wysłany przed wysłaniem awizacji.',
        waybillDisabledTooltip:
          'Każdy z wybranych rekordów musi posiadać uzupełniony numer kontenera lub miejsce podjęcia.',
        cloudManagement: 'Zarządzanie chmurą',
        cloudManagementStatuses: 'Statusy kontenera',
        cloudManagementDriversDatabase: 'Baza kierowców',
        driverAddSuccessMessage: 'Kierowca został dodany do bazy danych.',
        driverAddErrorMessage:
          'Kierowca z podanym dowodem osobistym już istnieje w bazie.',
        driverUpdateSuccessMessage:
          'Kierowca został zaktualizowany w bazie danych.',
        driverDeleteSuccessMessageSingle:
          'Kierowca został usunięty z bazy danych.',
        driverDeleteSuccessMessageMultiple:
          'Kierowcy zostali usunięci z bazy danych.',
        driverAddConfirm: 'Czy chcesz dodać nowego kierowcę do bazy danych?',
        driverEditConfirm: 'Czy chcesz zmienić dane kierowcy w bazie danych?',
        hexLabel: 'Hex',
        noColorTooltip: 'Bez koloru',
        statusAddSuccessMessage: 'Status został dodany.',
        statusUpdateSuccessMessage: 'Status został zaktualizowany.',
        statusDeleteSuccessMessageSingle: 'Status został usuniety.',
        statusDeleteSuccessMessageMultiple: 'Statusy zostały usunięte.',
      },
    },
    form: {
      title: 'Dodaj wpis transportowy',
      labels: {
        date: 'Data',
        amount: 'Ilość',
        customer: 'Klient',
        relation: 'Relacja',
        loadingDeliveryLocation: 'Miejsce Załadunku/Dostawy',
        truckersRate: 'Stawka Dla Przewoźnika',
        containerNumbers: 'Numery Kontenerów',
        comment: 'Uwagi',
        trucker: 'Przewoźnik',
        currency: 'Waluta',
        shipowner: 'Armator',
        containerSize: 'Wielkość Kontenera',
      },
      buttons: {
        addEntry: 'Dodaj wpis',
        save: 'Zapisz',
        cancel: 'Anuluj',
      },
      validation: {
        truckersRate: 'To pole jest wymagane, gdy podano walutę.',
        currency: 'To pole jest wymagane, gdy podano stawkę dla przewoźnika.',
        amount: 'Ilość musi być większa od zera.',
        containerNumbersISO: 'Wartości muszą spełniać standard ISO6346.',
        containerNumbersAmount:
          'Liczba numerów kontenerów nie może przekraczać określonej ilości.',
      },
    },
  },
  mapping: {
    internalActivity: 'Usługa spedycyjna',
    counterparty: 'Kontrahent',
    externalActivity: 'Usługa zewnętrzna',
    addInternalActivity: 'Dodaj usługę spedycyjną',
    addExternalActivity: 'Dodaj usługę zewnętrzną',
    deleteExternalActivity: 'Usuń usługę zewnętrzną',
    deleteExternalActivitySuccess: 'Usługa zewnętrzna została usunięta.',
    deleteExternalActivityError:
      'Wystąpił błąd podczas usuwania usługi zewnętrznej. Spróbuj ponownie.',
    confirmDeleteExternalActivity:
      'Czy na pewno chcesz usunąć wybrane usługi zewnętrzne?',
    all: 'Wszystkie',
    search: 'Szukaj',
    addExternalActivityError:
      'Wystąpił błąd podczas dodawania usługi zewnętrznej. Spróbuj ponownie.',
    addExternalActivitySuccess: 'Usługa zewnętrzna została dodana.',
    updateExternalActivityError:
      'Wystąpił błąd podczas edytowania usługi zewnętrznej. Spróbuj ponownie.',
    updateExternalActivitySuccess: 'Usługa zewnętrzna została zaktualizowana.',
    collapse: 'zwiń',
    servicesPlural1: 'usługa',
    servicesPlural2: 'usługi',
    servicesPlural3: 'usług',
    counterpartiesPlural1: 'kontrahent',
    counterpartiesPlural2: 'kontrahenci',
    counterpartiesPlural3: 'kontrahentów',
    notSpecified: 'Nie określono',
    patternEditDisabled:
      'Edycja schematu mapowania jest w tym momencie niedostępna.',
  },
  exchangeRate: {
    fromCurrency: 'Waluta wyjściowa',
    toCurrency: 'Waluta docelowa',
    rate: 'Kurs',
    multiplier: 'Mnożnik',
    type: 'Typ',
    date: 'Data',
    source: 'Źródło',
    registry: {
      registry: 'Rejestr',
      filename: 'Nazwa pliku',
      description: 'Opis',
      date: 'Data',
    },
    labels: {
      BID: 'Sprzedaż',
      ASK: 'Kupno',
      AVERAGE: 'Średni',
    },
    fromRate: 'Minimalny kurs',
    toRate: 'Maksymalny kurs',
  },
  door: {
    city: 'Door miasto',
    countryCode: 'Door kraj',
  },
  mail: {
    from: 'Od',
    to: 'Do',
    cc: 'DW',
    bcc: 'UDW',
    subject: 'Temat',
    send: 'Wyślij',
    header: 'Nowa wiadomość',
    job: 'Spedycja',
    offer: 'Oferta',
    successMessage: 'Wiadomość została wysłana.',
  },
  itemConfiguration: {
    itemType: 'Typ',
    tradeType: 'Relacja',
    loadType: 'Kategoria',
    tradeTypeLabels: {
      IMPORT: 'Import',
      EXPORT: 'Eksport',
      COUNTRY: 'Kraj',
    },
    loadTypeLabels: {
      FCL: 'FCL',
      LCL: 'LCL',
      FTL: 'FTL',
      LTL: 'LTL',
    },
    validationMessages: {
      anyField: 'Co najmniej jedno pole musi posiadać wartość',
    },
    activity: 'Usługa',
    unit: 'Jednostka',
    businessFunction: 'Kontrahent',
    currency: 'Waluta',
  },
  counterpartyImport: {
    import: 'Import danych z bazy danych GUS',
    captcha: 'Kod Captcha',
    number: 'Numer NIP',
    mode: 'Tryb',
    modes: {
      nip: 'NIP',
      regon: 'Regon',
    },
    getCaptcha: 'Odśwież kod captcha',
    importData: 'Importuj',
    loading: 'Wczytywanie',
    failed: 'Nie można wczytać',
  },
  address: {
    lineOne: 'Adres',
    lineTwo: 'Kod pocztowy',
    city: 'Miasto',
    countryCode: 'Kraj',
    addressDetails: 'Dane adresowe',
  },
  transportWaypoint: {
    address: 'Adres',
    date: 'Data',
    referenceNumber: 'Numer referencyjny',
  },
  entryRoute: {
    labels: {
      import: {
        start: 'Terminal',
        node: 'Rozładunek',
        end: 'Złożenie pustego',
      },
      export: {
        start: 'Podjęcie pustego',
        node: 'Załadunek',
        end: 'Terminal',
      },
      country: {
        node: 'Przystanek',
      },
      nodeTL: {
        start: 'Załadunek',
        end: 'Rozładunek',
      },
    },
    addManually: 'Dodaj ręcznie',
    addStorehouse: 'Zapisz magazyn',
  },
  reports: {
    invoice: {
      label: 'Raport faktur',
      invoiceCode: 'Numer faktury',
      jobCode: 'Numer spedycji',
      issueDate: 'Data wystawienia',
      saleDate: 'Data sprzedaży',
      amount: 'Kwota',
      dueDate: 'Termin płatności',
      dueDays: 'Termin płatności:',
      counterparty: 'Klient',
      unpaidTotal: 'Kwota niezapłaconych faktur',
      averageOverdue: 'Średnio dni po terminie',
      overdueDays: 'Dni po terminie',
      averageDelay: 'Średnie opóźnienie',
      including: 'W tym:',
      status: {
        label: 'Status',
        PAID: 'Zapłacone',
        NOT_PAID: 'Niezapłacone',
      },
      published: {
        label: 'Wszystkie',
        PUBLISHED: 'Opublikowane',
        UNPUBLISHED: 'Nieopublikowane',
      },
      ksefNumber: 'KSeF',
    },
    job: {
      label: 'Raport spedycji',
      forwarder: 'Spedytor',
      startExecutionDate: 'Od daty wykonania',
      endExecutionDate: 'Do daty wykonania',
      country: 'Kraj',
      city: 'Miasto',
      jobs: 'Liczba spedycji',
      containers: 'Liczba kontenerów',
      total: 'Razem:',
      tradeKeeper: 'Opiekun handlowy',
    },
    activity: {
      label: 'Raport aktywności',
      labelCP: 'Raport aktywności',
      customer: 'Klient',
      user: 'Użytkownik',
      requests: 'Zapytania',
      offers: 'Oferty',
      orders: 'Zamówienia',
      jobs: 'Spedycje',
      jobEntries: 'Ładunki',
      invoices: 'Faktury',
      type: {
        USER: 'Użytkownik',
        CUSTOMER: 'Klient',
      },
    },
    container: {
      label: 'Raport kontenerów',
      type: {
        RELATION: 'Relacja',
        USER: 'Użytkownik',
      },
      port: 'Port',
      region: 'Region',
      forwarder: 'Spedytor',
      customer: 'Klient',
      shippingLine: 'Armator',
    },
    offer: {
      label: 'Raport ofert',
      loadingPort: 'Port załadunku',
      unloadingPort: 'Port wyładunku',
      containerSize: 'Rozmiar kontenera',
      containerType: 'Typ kontenera',
      route: 'Trasa',
    },
    oceanSchedules: {
      label: 'Harmonogram frachtów',
      originPort: 'Port załadunku',
      destinationPort: 'Port wyładunku',
      searchDate: 'Data załadunku',
      searchDateType: 'Szukaj po dacie: ',
      directOnly: 'Transport bezpośredni',
      includeNearbyOriginPorts: 'Uwzględnij porty w pobliżu portu początkowego',
      includeNearbyDestinationPorts:
        'Uwzględnij porty w pobliżu portu docelowego',
      departureDate: 'Data załadunku',
      arrivalDate: 'Data rozładunku',
      weeksOut: 'Tygodnie',
      scacs: 'Armatorzy',
      shippingLine: 'Armator',
      cutOff: 'Cut-Off',

      generalInformation: 'Informacje ogólne',
      scac: 'SCAC przewoźnika',
      carrierName: 'Nazwa przewoźnika',
      terminalCutoff: 'Data odbioru ładunku',
      estimatedTerminalCutoff: 'Ramowa data odbioru ładunku',
      bkCutoff: 'Data zgłoszenia bookingu',
      siCutoff: 'Data instrukcji przewozowej',
      hazBkCutoff: 'Data bookingu ładunku niebezp.',
      vgmCutoff: 'Data wysłania VGM',
      reeferCutoff: 'Data bookingu z kontrolą temp.',
      serviceName: 'Nazwa usługi',
      vesselName: 'Nazwa statku',
      voyageNumber: 'Numer transportu',
      imoNumber: 'Numer IMO statku',
      originUnloc: 'Kod UNECE portu załadunku',
      originCityName: 'Port załadunku',
      originSubdivision: 'Stan/prowincja załadunku',
      originCountry: 'Kraj załadunku',
      originTerminal: 'Terminal załadunku',
      originDepartureDate: 'ETD',
      destinationUnloc: 'Kod UNECE portu docelowego',
      destinationCityName: 'Port docelowy',
      destinationSubdivision: 'Stan/prowincja docelowa',
      destinationCountry: 'Kraj docelowy',
      destinationTerminal: 'Terminal docelowego',
      destinationArrivalDate: 'ETA',
      totalDuration: 'TT',
      scheduleType: 'Rodzaj transportu',
      legs: 'Lista kolejnych portów',

      legsDetails: {
        sequence: 'Numer porządkowy',
        serviceName: 'Nazwa usługi',
        transportType: 'Rodzaj transportu',
        transportName: 'Nazwa statku',
        conveyanceNumber: 'Numer statku',
        transportID: 'Numer IMO statku',
        departureUnloc: 'Kod UNECE portu załad.',
        departureCityName: 'Miasto załadunku',
        departureSubdivision: 'Stan/prowincja załadunku',
        departureCountry: 'Kraj załadunku',
        departureTerminal: 'Port załądunku',
        departureDate: 'Data załadunku',
        arrivalUnloc: 'Kod UNECE portu rozładunku',
        arrivalCityName: 'Miasto rozładunku',
        arrivalSubdivision: 'Stan/prowincja rozładunku',
        arrivalCountry: 'Kraj rozładunku',
        arrivalTerminal: 'Port rozładunku',
        arrivalDate: 'Data dopł. do portu rozładunku',
        transitDuration: 'Czas podróży w dniach',
        transshipmentIndicator: 'Przeładunek w porcie rozładunku',
      },
    },
    import: 'Import',
    export: 'Eksport',
  },
  serviceTypes: {
    serviceTypeLabels: {
      ADMINISTRATIVE: 'Administracyjne',
      ALL_IN: 'All-in',
      AGENT: 'Agent',
      CUSTOMS: 'Odprawa celna',
      DEPOT: 'Depot',
      FREIGHT: 'Fracht',
      FREIGHT_MAINTENANCE: 'Okołofrachtowe',
      INSURANCE: 'Ubezpieczenie',
      OTHER: 'Inne',
      TERMINAL: 'Terminal',
      TRANSPORT: 'Transport lądowy',
    },
  },
  login: {
    info: 'Zaloguj się.',
    signin: 'Zaloguj',
    notsuccessful: 'Próba logowania nie powiodła się, spróbuj jeszcze raz.',
    logout: 'Wylogowanie powiodło się.',
    expired: 'Sesja wygasła.\nZaloguj się jeszcze raz.',
    userPlaceholder: 'Nazwa użytkownika',
    passwordPlaceholder: 'Hasło',
    accountExpired: 'Konto wygasło.',
    passwordExpired: 'Hasło jest nieważne, wprowadź nowe hasło.',
    locked: 'Konto jest zablokowane.',
    disabled: 'Konto jest nieaktywne.',
    passwordChanged: 'Hasło zostało zmienione.\nZaloguj się jeszcze raz.',
    newPasswordPlaceholder: 'Nowe hasło',
    newPasswordConfirmationPlaceholder: 'Powtórz nowe hasło',
    passwordsNotEqual: 'Pole jest wymagane',
    fieldRequired: 'Pole jest wymagane',
    acceptances: 'Zgody',
  },
  Containers: {
    isoCode: 'Kod ISO',
  },
  requestForOffer: {
    create: 'New request',
    code: 'Numer zapytania',
    send: 'Wyślij',
    print: 'Drukuj',
    requestRecipient: 'Odbiorca zapytania',
    sendingDate: 'Data wysłania',
    description: 'Uwagi',
    productName: 'Nazwa towaru',
    deliveryType: 'Rodzaj przesyłki',
    containerSorts: 'Rodzaje kontenerów',
    totalCargoWeight: 'Całkowita waga ładunku',
    totalCargoCapacity: 'Całkowita kubatura ładunku',
    loadType: 'Typ przesyłki',
    relations: 'Relacje',
    addRelation: 'Dodaj relację',
    loadingPoint: 'Miejsce załadunku',
    deliveryPoint: 'Miejsce dostawy',
    sendConfirmation: 'Czy na pewno chcesz wysłać to zapytanie ofertowe?',
    requestSent: 'Zapytanie wysłane',
    archive: 'Archiwizuj',
    receivingDate: 'Data otrzymania',
    status: 'Status',
    customer: 'Klient',
    addOffer: 'Dodaj ofertę',
    archiveConfirmation:
      'Czy na pewno chcesz zarchiwizować to zapytanie ofertowe?',
    onlyCurrent: 'Tylko aktualne',
    loadTypes: {
      FULL_LOAD: 'Pełen ładunek',
      PARTIAL_LOAD: 'Ładunek częściowy',
    },
    deliveryTypes: {
      CONTAINER: 'Kontener',
      TARPAULIN: 'Plandeka',
      SMALL_LOAD: 'Drobnica',
    },
    statuses: {
      CURRENT: 'Aktualny',
      ARCHIVED: 'Zarchiwizowany',
    },
  },
  regions: {
    countries: 'Kraje',
  },
  forecasts: {
    startingRegion: 'Region startowy',
    targetRegion: 'Region docelowy',
    forecast: 'Prognoza',
    diagram: 'Podgląd',
    date: 'Data',
    pmi: 'PMI',
    baf: 'BAF',
    tonnage: 'Tonaż',
    addPoint: 'Dodaj punkt',
    generatePreview: 'Generuj podgląd',
    chartTitle: 'Prognoza cen frachtu',
    relation: 'Relacja',
    currentPrice: 'Aktualna stawka',
    calculateForecast: 'Wylicz prognozę',
    warningLabelHeader: 'Uwaga!',
    warningLabelText:
      'Ze względu na niestabilną sytuację polityczną nie ma możliwości prognozy cen frachtów dla Afryki, Bliskiego Wschodu i Zatoki Perskiej',
    chartDateFormat: 'dd-MM-yyyy',
  },
  jpk: {
    fullName: 'Pełna nazwa',
    nip: 'NIP',
    regon: 'REGON',
    taxOfficeCode: 'Kod urzędu skarbowego',
    voivodeship: 'Województwo',
    district: 'Powiat',
    commune: 'Gmina',
    city: 'Miasto',
    countryCode: 'Kod kraju',
    street: 'Ulica',
    houseNumber: 'Numer domu',
    apartmentNumber: 'Numer lokalu',
    post: 'Poczta',
    postalCode: 'Kod pocztowy',
    primaryCounterpartyDataNotFilled:
      'Przed wygenerowanie pliku JPK konieczne jest uzupełnienie danych głównego kontrahenta.',
  },
  privileges: {
    sectionName: 'Uprawnienia',
    REQUESTS: {
      name: 'Zapytania',
      MODULE_REQUESTS_VIEW_LIST: 'Wyświetlanie listy zapytań',
      MODULE_REQUESTS_VIEW_DETAILS: 'Wyświetlanie szczegółów zapytania',
      MODULE_REQUESTS_ARCHIVE: 'Archiwizowanie zapytania',
      MODULE_REQUESTS_PRINT: 'Drukowanie zapytania',
    },
    NOTIFICATIONS: {
      name: 'Komunikaty',
      MODULE_NOTIFICATIONS_CONTAINERS:
        'Wyświetlanie komunikatów dot. kontenerów ',
      MODULE_NOTIFICATIONS_INVOICES: 'Wyświetlanie komunikatów dot. faktur',
      MODULE_NOTIFICATIONS_CARRIERS:
        'Wyświetlanie komunikatów dot. przewoźników',
    },
    OFFERS: {
      name: 'Oferty',
      MODULE_OFFERS_VIEW_OFFER_LIST: 'Wyświetlanie listy ofert',
      MODULE_OFFERS_VIEW_OFFER_DETAILS: 'Wyświetlanie szczegółów oferty',
      MODULE_OFFERS_CREATE_OFFER: 'Dodawanie oferty',
      MODULE_OFFERS_EDIT_OFFER: 'Edycja ofert',
      MODULE_OFFERS_EDIT_OFFER_OWNER: 'Edycja ofert (właściciel)',
      MODULE_OFFERS_DELETE_OFFER: 'Usuwanie ofert',
      MODULE_OFFERS_DELETE_OFFER_OWNER: 'Usuwanie ofert (właściciel)',
      MODULE_OFFERS_ADD_OFFER_ITEM: 'Dodawanie pozycji oferty',
      MODULE_OFFERS_ADD_OFFER_ITEM_OWNER:
        'Dodawanie pozycji oferty (właściciel)',
      MODULE_OFFERS_VIEW_ITEM_DETAILS: 'Wyświetlanie szczegółów pozycji oferty',
      MODULE_OFFERS_EDIT_ITEM_DETAILS: 'Edycja pozycji oferty',
      MODULE_OFFERS_EDIT_ITEM_DETAILS_OWNER:
        'Edycja pozycji oferty (właściciel)',
      MODULE_OFFERS_COPY_ITEM: 'Kopiowanie pozycji oferty',
      MODULE_OFFERS_COPY_ITEM_OWNER: 'Kopiowanie pozycji oferty (właściciel)',
      MODULE_OFFERS_COPY_OFFER: 'Kopiowanie ofert',
      MODULE_OFFERS_COPY_OFFER_OWNER: 'Kopiowanie ofert (właściciel)',
      MODULE_OFFERS_PUBLISH_OFFER: 'Publikownie oferty',
      MODULE_OFFERS_PUBLISH_OFFER_OWNER: 'Publikownie oferty (właściciel)',
      MODULE_OFFERS_ADD_ANEX_TO_OFFER: 'Dodawanie aneksu do oferty',
      MODULE_OFFERS_ADD_ANEX_TO_OFFER_WHICH_RESULTED_IN_JOB:
        'Dodawanie aneksu do oferty na podstawie spedycji',
      MODULE_OFFERS_PRINT_OFFER: 'Drukowanie ofert',
      MODULE_OFFERS_MAIL_OFFER: 'Wysyłanie e-mail z ofertą',
      MODULE_OFFERS_MAIL_OFFER_OWNER: 'Wysyłanie e-mail z ofertą (właściciel)',
      MODULE_OFFERS_CREATE_JOB_FROM_OFFER: 'Tworzenie spedycji z oferty',
    },
    ORDERS: {
      name: 'Zlecenia',
      MODULE_ORDERS_VIEW_ORDER_LIST: 'Wyświetlanie listy zleceń',
      MODULE_ORDERS_VIEW_ORDER_DETAILS: 'Wyświetlanie szczegółów zlecenia',
      MODULE_ORDERS_PRINT_ORDER: 'Drukowanie zleceń',
      MODULE_ORDERS_CHANGE_ORDER_STATUS: 'Zmiana statusu zlecenia',
      MODULE_ORDERS_CREATE_JOB_FROM_ORDER: 'Tworzenie spedycji ze zlecenia',
    },
    JOBS: {
      name: 'Spedycje',
      MODULE_JOBS_VIEW_JOB_LIST: 'Wyświetlanie listy spedycji',
      MODULE_JOBS_VIEW_JOB_DETAILS: 'Wyświetlanie szczegółów spedycji',
      MODULE_JOBS_EDIT_JOB: 'Edycja spedycji',
      MODULE_JOBS_EDIT_JOB_OWNER: 'Edycja spedycji (właściciel)',
      MODULE_JOBS_DELETE_JOB: 'Usuwanie spedycji',
      MODULE_JOBS_DELETE_JOB_OWNER: 'Usuwanie spedycji (właściciel)',
      MODULE_JOBS_ADD_EVENT: 'Dodawanie zdarzenia spedycji',
      MODULE_JOBS_ADD_EVENT_OWNER: 'Dodawanie zdarzenia (właściciel)',
      MODULE_JOBS_DELETE_EVENT: 'Usuwanie zdarzenia',
      MODULE_JOBS_DELETE_EVENT_OWNER: 'Usuwanie zdarzenia (właściciel)',
      MODULE_JOBS_ADD_LOAD: 'Dodawanie ładunku',
      MODULE_JOBS_ADD_LOAD_OWNER: 'Dodawanie ładunku (właściciel)',
      MODULE_JOBS_COPY_LOAD: 'Kopiowanie ładunku',
      MODULE_JOBS_COPY_LOAD_OWNER: 'Kopiowanie ładunku (właściciel)',
      MODULE_JOBS_DELETE_LOAD: 'Kasowanie ładunku',
      MODULE_JOBS_DELETE_LOAD_OWNER: 'Kasowanie ładunku (właściciel)',
      MODULE_JOBS_ADD_SERVICE: 'Dodawanie usługi',
      MODULE_JOBS_ADD_SERVICE_OWNER: 'Dodawanie usługi (właściciel)',
      MODULE_JOBS_COPY_SERVICE: 'Kopiowanie usługi',
      MODULE_JOBS_COPY_SERVICE_OWNER: 'Kopiowanie usługi (właściciel)',
      MODULE_JOBS_DELETE_SERVICE: 'Kasowanie usługi',
      MODULE_JOBS_DELETE_SERVICE_OWNER: 'Kasowanie usługi (właściciel)',
      MODULE_JOBS_GENERATE_DOWNLOAD_DOCUMENTS:
        'Generowanie i pobieranie dokumentów',
      MODULE_JOBS_MAIL_DOCUMENTS: 'Wysyłanie dokumentów',
      MODULE_JOBS_MAIL_DOCUMENTS_OWNER: 'Wysyłanie dokumentów (właściciel)',
      MODULE_JOBS_SEND_EDI_MESSAGE: 'Wysyłanie komunikatów EDI',
      MODULE_JOBS_SEND_EDI_VGM_MESSAGE: 'Wysyłanie komunikatów EDI VGM',
      MODULE_JOBS_CREATE_INVOICE_FROM_JOB: 'Tworzenie faktury ze spedycji',
      MODULE_JOBS_ADD_STOREHOUSE: 'Dodawanie magazynu',
      MODULE_JOBS_VIEW_TRACK_AND_TRACE:
        'Wyświetlanie szczegółów Track and Trace',
      MODULE_JOBS_SEND_CONTAINER_NOTIFICATION: 'Wysyłanie awizacji kontenera',
      MODULE_JOBS_RELEASE_DETENTION_STATUS:
        'Zdejmowanie statusu kontroli celnej kontenera',
    },
    INVOICES: {
      name: 'Faktury',
      MODULE_INVOICES_VIEW_INVOICE_LIST: 'Wyświetlanie listy faktur',
      MODULE_INVOICES_VIEW_INVOICE_DETAILS: 'Wyświetlanie szczegółów faktury',
      MODULE_INVOICES_CREATE_OWN_INVOICE: 'Tworzenie faktur własnych',
      MODULE_INVOICES_CREATE_ADMIN_INVOICE:
        'Tworzenie faktur administracyjnych',
      MODULE_INVOICES_ADD_FOREIGN_INVOICE: 'Dodawanie faktur obcych',
      MODULE_INVOICES_DELETE_OWN_INVOICE_OWNER:
        'Usuwanie faktur własnych (właściciel)',
      MODULE_INVOICES_DELETE_OWN_INVOICE_UNPUBLISHED:
        'Usuwanie faktur własnych (nieopublikowane)',
      MODULE_INVOICES_DELETE_FOREIGN_INVOICE_UNPUBLISHED:
        'Usuwanie faktur obcych (nieopublikowane)',
      MODULE_INVOICES_DELETE_ADMIN_INVOICE_OWNER:
        'Usuwanie faktur administracyjnych (właściciel)',
      MODULE_INVOICES_DELETE_ADMIN_INVOICE_UNPUBLISHED:
        'Usuwanie faktur administracyjnych (nieopublikowane)',
      MODULE_INVOICES_PRINT_INVOICE: 'Drukowanie faktur',
      MODULE_INVOICES_PUBLISH_OWN_INVOICE: 'Publikowanie faktur własnych',
      MODULE_INVOICES_PUBLISH_OWN_INVOICE_OWNER:
        'Publikowanie faktur własnych (właściciel)',
      MODULE_INVOICES_PUBLISH_FOREIGN_INVOICE: 'Publikowanie faktur obcych',
      MODULE_INVOICES_PUBLISH_ADMIN_INVOICE:
        'Publikowanie faktur administracyjnych',
      MODULE_INVOICES_PUBLISH_ADMIN_INVOICE_OWNER:
        'Publikowanie faktur administracyjnych (właściciel)',
      MODULE_INVOICES_EDIT_OWN_INVOICE: 'Edycja faktur własnych',
      MODULE_INVOICES_EDIT_OWN_INVOICE_OWNER:
        'Edycja faktur własnych (właściciel)',
      MODULE_INVOICES_EDIT_FOREIGN_INVOICE: 'Edycja faktur obcych',
      MODULE_INVOICES_EDIT_ADMIN_INVOICE: 'Edycja faktur administracyjnych',
      MODULE_INVOICES_EDIT_ADMIN_INVOICE_OWNER:
        'Edycja faktur administracyjnych (właściciel)',
      MODULE_INVOICES_ADD_ALLOCATION: 'Dodawanie alokacji',
      MODULE_INVOICES_REVIEW_ALLOCATION:
        'Akceptowanie/reklamowanie/odrzucanie alokacji',
      MODULE_INVOICES_DELETE_ALLOCATION: 'Usuwanie alokacji',
      MODULE_INVOICES_SETTLE_OWN_INVOICE: 'Rozliczanie faktur własnych',
      MODULE_INVOICES_SETTLE_OWN_INVOICE_OWNER:
        'Rozliczanie faktur własnych (właściciel)',
      MODULE_INVOICES_SETTLE_FOREIGN_INVOICE: 'Rozliczanie faktur obcych',
      MODULE_INVOICES_SETTLE_ADMIN_INVOICE:
        'Rozliczanie faktur administracyjnych',
      MODULE_INVOICES_SETTLE_ADMIN_INVOICE_OWNER:
        'Rozliczanie faktur administracyjnych (właściciel)',
      MODULE_INVOICES_MAIL_OWN_INVOICE: 'Wysyłanie faktur własnych',
      MODULE_INVOICES_MAIL_OWN_INVOICE_OWNER:
        'Wysyłanie faktur własnych (właściciel)',
      MODULE_INVOICES_MAIL_FOREIGN_INVOICE: 'Wysyłanie faktur obcych',
      MODULE_INVOICES_MAIL_ADMIN_INVOICE: 'Wysyłanie faktur administracyjnych',
      MODULE_INVOICES_MAIL_ADMIN_INVOICE_OWNER:
        'Wysyłanie faktur administracyjnych (właściciel)',
      MODULE_INVOICES_EXPORT_INVOICE: 'Eksport faktur',
      MODULE_INVOICES_CREATE_OWN_CORRECTIVE_INVOICE_FOR_NON_SYSTEM_INVOICE:
        'Dodawanie faktur korygujących dla faktur z poza systemu',
    },
    REPORTS: {
      name: 'Raporty i prognozy',
      MODULE_REPORTS_VIEW_ACTIVITY_REPORT:
        'Wyświetlanie i drukowanie raportu aktywności',
      MODULE_REPORTS_VIEW_CONTAINERS_REPORT:
        'Wyświetlanie i drukowanie raportu kontenerów',
      MODULE_REPORTS_VIEW_INVOICES_REPORT:
        'Wyświetlanie i drukowanie raportu faktur',
      MODULE_REPORTS_VIEW_OFFERS_REPORT:
        'Wyświetlanie i drukowanie raportu ofert',
      MODULE_REPORTS_VIEW_JOB_REPORT:
        'Wyświetlanie i drukowanie raportu spedycji',
      MODULE_REPORTS_VIEW_FORECAST: 'Wyświetlanie i drukowanie prognoz',
      MODULE_REPORTS_VIEW_OCEAN_SCHEDULES: 'Wyświetlanie harmonogramu frachtów',
    },
    COUNTERPARTIES: {
      name: 'Kontrahenci',
      MODULE_COUNTERPARTIES_VIEW_COUNTERPARTY_DETAILS:
        'Wyświetlanie szczegółów kontrahenta',
      MODULE_COUNTERPARTIES_CREATE_COUNTERPARTY: 'Dodawanie kontrahenta',
      MODULE_COUNTERPARTIES_DELETE_COUNTERPARTY: 'Usuwanie kontrahenta',
      MODULE_COUNTERPARTIES_EDIT_COUNTERPARTY_DETAILS: 'Edycja kontrahenta',
      MODULE_COUNTERPARTIES_ADD_COUNTERPARTY_FUNCTION:
        'Dodawanie funkcji kontrahenta',
      MODULE_COUNTERPARTIES_DELETE_COUNTERPARTY_FUNCTION:
        'Usuwanie funkcji kontrahenta',
      MODULE_COUNTERPARTIES_MANAGE_ASSETS:
        'Zarządzanie wizytówkami/kontami/placami/magazynami',
      MODULE_COUNTERPARTIES_MANAGE_TRUCKERS: 'Zarządzanie przewoźnikami',
      MODULE_COUNTERPARTIES_DELETE_FILE: 'Usuwanie pliku',
      MODULE_COUNTERPARTIES_EXPORT_TABLES: 'Eksport tabel',
    },
    TABLES: {
      name: 'Tabele',
      MODULE_TABLES_MANAGE_TABLE_ITEM: 'Zarządzanie wpisami w tabelach',
      MODULE_TABLES_MANAGE_PORT_ITEM: 'Zarządzanie portami',
      MODULE_TABLES_EXPORT_TABLES: 'Eksport tabel',
    },
    PRICES: {
      name: 'Cenniki',
      MODULE_PRICES_MANAGE_PRICE_ITEM: 'Zarządzanie cennikiem',
      MODULE_PRICES_EXPORT_PRICES: 'Eksport cenników',
    },
    ADMIN: {
      name: 'Administracja',
      MODULE_ADMIN_VIEW_GROUP_LIST: 'Wyświetlanie listy grup',
      MODULE_ADMIN_VIEW_GROUP_DETAILS: 'Wyświetlanie szczegółów grupy',
      MODULE_ADMIN_MANAGE_GROUP: 'Zarządzanie grupami',
      MODULE_ADMIN_EXPORT_GROUP: 'Eksport grup',
      MODULE_ADMIN_VIEW_BRANCHES_LIST: 'Wyświetlanie listy oddziałów',
      MODULE_ADMIN_VIEW_BRANCHES_DETAILS: 'Wyświetlanie szczegółów oddziału',
      MODULE_ADMIN_MANAGE_BRANCHES: 'Zarządzanie oddziałami',
      MODULE_ADMIN_EXPORT_BRANCHES: 'Eksport oddziałów',
      MODULE_ADMIN_VIEW_USER_LIST: 'Wyświetlanie listy użytkowników',
      MODULE_ADMIN_VIEW_USER_DETAILS: 'Wyświetlanie szczegółów użytkownika',
      MODULE_ADMIN_MANAGE_USER: 'Zarządzanie użytkownikami',
      MODULE_ADMIN_EXPORT_USERS: 'Eksport użytkowników',
      MODULE_ADMIN_VIEW_PARAMETER_LIST: 'Wyświetlanie listy paramterów',
      MODULE_ADMIN_VIEW_PARAMETER_DETAILS: 'Wyświetlanie szczegółów paramteru',
      MODULE_ADMIN_MANAGE_PARAMETER: 'Zarządzanie parametrami',
      MODULE_ADMIN_EXPORT_PARAMETERS: 'Eksport parametrów',
      MODULE_ADMIN_JPK: 'Wyświetlanie/generowanie JPK',
      MODULE_ADMIN_PRIMARY_COUNTERPARTY:
        'Wyświetlanie/edytowanie głównego kontrahenta',
      MODULE_ADMIN_VIEW_ROLE_LIST: 'Wyświetlanie listy ról',
      MODULE_ADMIN_VIEW_ROLE_DETAILS: 'Wyświetlanie szczegółów roli',
      MODULE_ADMIN_MANAGE_ROLE: 'Zarządzanie rolami',
      MODULE_ADMIN_EXPORT_ROLE: 'Eksport ról',
      MODULE_ADMIN_VIEW_SERVICE_TERMS_LIST:
        'Wyświetlanie listy ogólnych warunków świadczenia usług',
      MODULE_ADMIN_VIEW_SERVICE_TERMS_DETAILS:
        'Wyświetlanie szczegółów ogólnych warunków świadczenia usług',
      MODULE_ADMIN_MANAGE_SERVICE_TERMS:
        'Zarządzanie ogólnymi warunkami świadczenia usług',
      MODULE_ADMIN_MONITORING: 'Monitorowanie aplikacji',
    },
    SETTINGS: {
      name: 'Ustawienia',
      MODULE_SETTINGS_VIEW_DISCRIMINANT_LIST: 'Wyświetlanie listy wyróżników',
      MODULE_SETTINGS_VIEW_DISCRIMINANT_DETAIL:
        'Wyświetlanie szczegółów wyróżnika',
      MODULE_SETTINGS_MANAGE_DISCRIMINANT: 'Zarządzanie wyróżnikami',
    },
    UAM: {
      name: 'Moje konto',
      MODULE_UAM_DATA_SECTION: 'Sekcja Dane',
      MODULE_UAM_REPLACEMENT_SECTION: 'Sekcja Zastępstwa',
      MODULE_UAM_PASSWORD_SECTION: 'Sekcja Hasło',
      MODULE_UAM_EMAIL_SECTION: 'Sekcja Ustawienia email',
    },
    CALENDAR: {
      name: 'Kalendarz',
      MODULE_CALENDAR_MANAGE_CALENDAR: 'Zarządzanie kalendarzem',
    },
    CLIENT: {
      name: 'Klient',
      MODULE_CLIENT_GENERAL: 'Klient',
    },
  },
  serviceTerms: {
    allLanguagesAreSet: 'OWŚU zostały ustawione dla wszystkich języków.',
  },
  calendar: {
    calendarLabel: 'Kalendarz',
    activityListLabel: 'Lista aktywności',
    event: {
      event: 'Wydarzenie',
      title: 'Tytuł',
      allDay: 'Wydarzenie całodniowe',
      startDate: 'Początek',
      endDate: 'Koniec',
      participants: 'Uczestnicy',
      realized: 'Zrealizowane',
      type: {
        MEETING: 'Spotkanie',
        OFFER: 'Oferta',
        PHONE: 'Telefon',
        OTHER: 'Inne',
        ALL: 'Wszystkie',
      },
      activityType: 'Typ aktywności',
      counterparty: 'Kontrahent',
      counterpartysFiles: 'Pliki kontrahenta',
      description: 'Opis',
      link: 'Link',
      from: 'Od',
      until: 'Do',
      highPriority: 'Wysoki priorytet',
    },
    createNewEvent: 'Utwórz wydarzenie',
    newEvent: 'Nowe wydarzenie',
    startDateBeforeEndDate: 'Data początku musi być przed datą końca',
  },
  trackAndTrace: {
    // trackAndTraceStatusDescription: trackAndTraceStatusDescription,
    modalHeader: 'Track & Trace dla kontenera: ',
    statusesTableModalHeader: 'Historia statusów Track & Trace',
    locationName: 'Location',
    status: 'Status',
    statusCode: 'Kod statusu',
    statusCodeDecoded: 'Description',
    statusDate: 'Date (GMT)',
    voyage: 'Voyage',
    vessel: 'Vessel',
  },
  ebl: {
    modalHeader: 'Szczegóły eBL dla: ',
    documentType: 'Rodzaj dokumentu',
    linkToFile: 'Link do dokumentu',
    documentNumber: 'Numer dokumentu',
    fileName: 'Nazwa pliku',
    comment: 'Komentarz',
  },
};
